{
  "select manual upload as the data source before uploading": {
    "en": "Select Manual upload as the data source before uploading",
    "nl": "Selecteer Handmatige upload als databron voordat je meetdata uploadt"
  },
  "cooling data must be stored on a cooling meter below a district-heating connection": {
    "en": "Cooling data must be stored on a cooling meter below a district-heating connection",
    "nl": "Koudegegevens horen bij een koudemeter onder een stadswarmteaansluiting"
  },
  "cooling meter": {
    "en": "Cooling meter",
    "nl": "Koudemeter"
  },
  "cooling belongs to the heat meter on this connection.": {
    "en": "Cooling belongs to the heat meter on this connection.",
    "nl": "Koude hoort bij de warmtemeter op deze aansluiting."
  },
  "add cooling below a district-heating connection": {
    "en": "Add cooling below a district-heating connection",
    "nl": "Voeg koude toe onder een stadswarmteaansluiting"
  },
  "cooling requires an active heat meter on a district-heating connection": {
    "en": "Cooling requires an active heat meter on a district-heating connection",
    "nl": "Koude vereist een actieve warmtemeter op een stadswarmteaansluiting"
  },
  "remove or stop the cooling meter before removing or stopping its heat meter": {
    "en": "Remove or stop the cooling meter before removing or stopping its heat meter",
    "nl": "Verwijder of stop eerst de koudemeter voordat je de warmtemeter verwijdert of stopt"
  },
  "this connection already has an active cooling data source": {
    "en": "This connection already has an active cooling data source",
    "nl": "Deze aansluiting heeft al een actieve gegevensbron voor koude"
  },
  "a connection with a cooling meter must remain a district-heating connection": {
    "en": "A connection with a cooling meter must remain a district-heating connection",
    "nl": "Een aansluiting met een koudemeter moet een stadswarmteaansluiting blijven"
  },
  "the cooling meter role is managed by its source": {
    "en": "The cooling meter role is managed by its source",
    "nl": "Het type koudemeter wordt door de bron beheerd"
  },
  "a cooling meter can only store cooling measurements": {
    "en": "A cooling meter can only store cooling measurements",
    "nl": "Een koudemeter kan alleen koudemetingen opslaan"
  },
  "co2 factor source": {
    "en": "CO₂ factor source",
    "nl": "Bron CO₂-factor"
  },
  "cooling co2 factor": {
    "en": "Cooling CO₂ factor",
    "nl": "CO₂-factor koude"
  },
  "use a factor for this source and period. leave blank if unknown.": {
    "en": "Use a factor for this source and period. Leave blank if unknown.",
    "nl": "Gebruik een factor voor deze bron en periode. Laat leeg als deze onbekend is."
  },
  "cooling co2 factor missing; subtotal excludes": {
    "en": "Cooling CO₂ factor missing; subtotal excludes",
    "nl": "CO₂-factor voor koude ontbreekt; subtotaal is exclusief"
  },
  "co² from cooling": {
    "en": "CO₂ from cooling",
    "nl": "CO₂ uit koude"
  },
  "cooling costs": {
    "en": "Cooling costs",
    "nl": "Kosten koude"
  },
  "weii heat weight": {
    "en": "WEii heat weight",
    "nl": "WEii-weegfactor warmte"
  },
  "weii cooling weight": {
    "en": "WEii cooling weight",
    "nl": "WEii-weegfactor koude"
  },
  "weighted heat (kwh)": {
    "en": "Weighted heat (kWh)",
    "nl": "Gewogen warmte (kWh)"
  },
  "weighted cooling (kwh)": {
    "en": "Weighted cooling (kWh)",
    "nl": "Gewogen koude (kWh)"
  },
  "heat (gj)": {
    "en": "Heat (GJ)",
    "nl": "Warmte (GJ)"
  },
  "cooling (gj)": {
    "en": "Cooling (GJ)",
    "nl": "Koude (GJ)"
  },
  "utcoffsetseconds": {
    "en": "UTC offset at start (seconds)",
    "nl": "UTC-tijdverschil bij start (seconden)"
  },
  "durationseconds": {
    "en": "Interval duration (seconds)",
    "nl": "Intervalduur (seconden)"
  },
  "portfolio": {
    "en": "Portfolio",
    "nl": "Portfolio"
  },
  "default": {
    "en": "Default",
    "nl": "Standaard"
  },
  "locations": {
    "en": "Locations",
    "nl": "Locaties"
  },
  "building type backfill proposal": {
    "en": "Building type backfill proposal",
    "nl": "Voorstel ontbrekende gebouwtypen"
  },
  "reports": {
    "en": "Reports",
    "nl": "Rapporten"
  },
  "van Dorp Report": {
    "en": "Van Dorp Report",
    "nl": "Van Dorp rapport"
  },
  "configuration": {
    "en": "Configuration",
    "nl": "Beheer"
  },
  "organisations": {
    "en": "Organisations",
    "nl": "Organisaties"
  },
  "connections": {
    "en": "Connections",
    "nl": "Aansluitingen"
  },
  "connections list": {
    "en": "Connections",
    "nl": "Aansluitlijst"
  },
  "authorisations": {
    "en": "Authorisations",
    "nl": "Autorisaties"
  },
  "save changes": {
    "en": "Save changes",
    "nl": "Wijzigingen opslaan"
  },
  "logo": {
    "en": "Logo",
    "nl": "Logo"
  },
  "portfolio icon": {
    "en": "Portfolio icon",
    "nl": "Portfolio icoon"
  },
  "flowmaps": {
    "en": "Flowmaps",
    "nl": "Flowmaps"
  },
  "toggle navigation": {
    "en": "Toggle navigation",
    "nl": "Toggle navigation"
  },
  "profile": {
    "en": "Profile",
    "nl": "Profiel"
  },
  "edsn disconnected alerts": {
    "en": "EDSN disconnected alerts",
    "nl": "EDSN-meldingen: Niet verbonden"
  },
  "alert from the past week": {
    "en": "alert from the past week",
    "nl": "melding in de afgelopen week"
  },
  "alerts from the past week": {
    "en": "alerts from the past week",
    "nl": "meldingen in de afgelopen week"
  },
  "past week": {
    "en": "Past week",
    "nl": "Afgelopen week"
  },
  "view alerts": {
    "en": "View alerts",
    "nl": "Meldingen bekijken"
  },
  "encrypt": {
    "en": "Encrypt",
    "nl": "Versleutelen"
  },
  "logout": {
    "en": "Logout",
    "nl": "Uitloggen"
  },
  "search": {
    "en": "Search",
    "nl": "Zoek"
  },
  "overview": {
    "en": "Overview",
    "nl": "Overzicht"
  },
  "add organisation": {
    "en": "Add organisation",
    "nl": "Organisatie toevoegen"
  },
  "connection information": {
    "en": "Connection details",
    "nl": "Aansluitingsdetails"
  },
  "please enter a location": {
    "en": "Please enter a location",
    "nl": "Voer een locatie in"
  },
  "electricity": {
    "en": "Electricity",
    "nl": "Elektriciteit"
  },
  "gas": {
    "en": "Gas",
    "nl": "Gas"
  },
  "heat": {
    "en": "Heat",
    "nl": "Warmte"
  },
  "water": {
    "en": "Water",
    "nl": "Water"
  },
  "code": {
    "en": "Code",
    "nl": "EAN"
  },
  "please enter a code": {
    "en": "Please enter a code",
    "nl": "Voer een EAN in"
  },
  "meter number": {
    "en": "Meter number",
    "nl": "Meternummer"
  },
  "customer id": {
    "en": "Customer id",
    "nl": "Klantnummer"
  },
  "meter numbers": {
    "en": "Meter numbers",
    "nl": "Meternummers"
  },
  "please enter a meter numbers": {
    "en": "Please enter a meter numbers",
    "nl": "Voer een meternummer in"
  },
  "label": {
    "en": "Label",
    "nl": "Label"
  },
  "please enter a label": {
    "en": "Please enter a label",
    "nl": "Voer een label in"
  },
  "market segment": {
    "en": "Market segment",
    "nl": "Marktsegment"
  },
  "kv": {
    "en": "KV",
    "nl": "KV"
  },
  "gv": {
    "en": "GV",
    "nl": "GV"
  },
  "please enter a market segment": {
    "en": "Please enter a market segment",
    "nl": "Voer een marktsegment in"
  },
  "supplier": {
    "en": "Supplier",
    "nl": "Leverancier"
  },
  "please enter a supplier": {
    "en": "Please enter a supplier",
    "nl": "Voer een leverancier in"
  },
  "operator": {
    "en": "Operator",
    "nl": "Netbeheerder"
  },
  "please enter an operator": {
    "en": "Please enter an operator",
    "nl": "Voer een netbeheerder in"
  },
  "supplier contract": {
    "en": "Supplier contract",
    "nl": "Contract"
  },
  "please enter a supplier contract": {
    "en": "Please enter a supplier contract",
    "nl": "Voer een contract in"
  },
  "change contract owner": {
    "en": "Change contract owner",
    "nl": "Contractbeheerder wijzigen"
  },
  "select a new owner for this contract": {
    "en": "Select a new owner for this contract",
    "nl": "Selecteer een nieuwe contractbeheerder voor dit contract"
  },
  "data source": {
    "en": "Data source",
    "nl": "Databron"
  },
  "submeter data source": {
    "en": "Submeter data source",
    "nl": "Databron tussenmeters"
  },
  "please enter a data source": {
    "en": "Please enter a data source",
    "nl": "Voer een databron in"
  },
  "search for a location": {
    "en": "Search a location",
    "nl": "Zoek een locatie"
  },
  "select an organisation": {
    "en": "Select an organisation",
    "nl": "Kies een organisatie"
  },
  "select connection:": {
    "en": "Select Connection:",
    "nl": "Kies een aansluiting:"
  },
  "authorisation for": {
    "en": "Authorisation for",
    "nl": "Machtiging voor"
  },
  "dashboard": {
    "en": "Dashboard",
    "nl": "Dashboard"
  },
  "save dashboard": {
    "en": "Save dashboard",
    "nl": "Dashboard opslaan"
  },
  "electricity consumption": {
    "en": "Electricity consumption",
    "nl": "Elektriciteitsverbruik"
  },
  "electricity consumption normal": {
    "en": "Electricity consumption normal",
    "nl": "Elektriciteitsverbruik normaal"
  },
  "electricity consumption (estimated)": {
    "en": "Electricity consumption (estimated)",
    "nl": "Elektriciteitsverbruik (geschat)"
  },
  "electricity consumption tax": {
    "en": "Electricity consumption tax",
    "nl": "Belasting op elektriciteit"
  },
  "electricity consumption off-peak": {
    "en": "Electricity consumption off-peak",
    "nl": "Elektriciteitsverbruik dal"
  },
  "building consumption normal": {
    "en": "Building consumption normal",
    "nl": "Gebouwverbruik normaal"
  },
  "building consumption off-peak": {
    "en": "Building consumption off-peak",
    "nl": "Gebouwverbruik dal"
  },
  "of total electricity": {
    "en": "of total electricity",
    "nl": "van het totale elektriciteitsverbruik"
  },
  "total electricity consumption": {
    "en": "Total electricity consumption",
    "nl": "Totaal elektriciteitsverbruik"
  },
  "consumption outside selection": {
    "en": "Consumption outside selection",
    "nl": "Verbruik buiten selectie"
  },
  "main meter": {
    "en": "Main meter",
    "nl": "Hoofdmeter"
  },
  "charging share": {
    "en": "Charging share",
    "nl": "Laadaandeel"
  },
  "electricity production": {
    "en": "Electricity production",
    "nl": "Elektriciteitsproductie"
  },
  "electricity production off-peak": {
    "en": "Electricity production off-peak",
    "nl": "Elektriciteitsproductie dal"
  },
  "electricity reactive consumption": {
    "en": "Electricity reactive consumption",
    "nl": "Blindverbruik"
  },
  "electricity reactive consumption normal": {
    "en": "Electricity reactive consumption normal",
    "nl": "Blindverbruik normaal"
  },
  "electricity reactive consumption off-peak": {
    "en": "Electricity reactive consumption off-peak",
    "nl": "Blindverbruik dal"
  },
  "electricity reactive production": {
    "en": "Electricity reactive production",
    "nl": "Blindverbruik teruglevering"
  },
  "electricity reactive production normal": {
    "en": "Electricity reactive production normal",
    "nl": "Blindverbruik teruglevering normaal"
  },
  "electricity reactive production off-peak": {
    "en": "Electricity reactive production off-peak",
    "nl": "Blindverbruik teruglevering dal"
  },
  "electricity feed-in": {
    "en": "Electricity feed-in",
    "nl": "Teruglevering"
  },
  "electricity feed-in normal": {
    "en": "Electricity feed-in normal",
    "nl": "Teruglevering normaal"
  },
  "electricity feed-in off-peak": {
    "en": "Electricity feed-in off-peak",
    "nl": "Teruglevering dal"
  },
  "location ranking": {
    "en": "Location ranking",
    "nl": "Locatierangschikking"
  },
  "meter ranking": {
    "en": "Meter ranking",
    "nl": "Meter rangschikking"
  },
  "submeter ranking": {
    "en": "Submeter ranking",
    "nl": "Tussenmeter rangschikking"
  },
  "measured gross pv production": {
    "en": "Measured gross PV production",
    "nl": "Gemeten bruto PV-productie"
  },
  "edit label": {
    "en": "Edit label",
    "nl": "Label bewerken"
  },
  "costs": {
    "en": "Costs",
    "nl": "Kosten"
  },
  "gas consumption": {
    "en": "Gas consumption",
    "nl": "Gasverbruik"
  },
  "gas consumption per hdd": {
    "en": "Gas consumption per HDD",
    "nl": "Gasverbruik per graaddag"
  },
  "gas consumption (estimated)": {
    "en": "Gas consumption (estimated)",
    "nl": "Gasverbruik (geschat)"
  },
  "gas consumption tax": {
    "en": "Gas consumption tax",
    "nl": "Belasting op gas"
  },
  "gas consumption uncorrected": {
    "en": "Gas consumption uncorrected",
    "nl": "Ongecorrigeerd gasverbruik"
  },
  "water consumption": {
    "en": "Water consumption",
    "nl": "Waterverbruik"
  },
  "water consumption (estimated)": {
    "en": "Water consumption (estimated)",
    "nl": "Waterverbruik (geschat)"
  },
  "water consumption tax": {
    "en": "Water consumption tax",
    "nl": "Belasting op water"
  },
  "water intermediate consumption": {
    "en": "Water sub-meter consumption",
    "nl": "Tussenmeterverbruik water"
  },
  "gas and heat consumption": {
    "en": "Gas and heat consumption",
    "nl": "Gas- en warmteverbruik"
  },
  "gas and heat consumption per hdd": {
    "en": "Gas and heat consumption per HDD",
    "nl": "Gas- en warmteverbruik per graaddag"
  },
  "show consumption per hdd": {
    "en": "Show consumption per HDD",
    "nl": "Toon verbruik per graaddag"
  },
  "per hdd": {
    "en": "per HDD",
    "nl": "per graaddag"
  },
  "hdd": {
    "en": "HDD",
    "nl": "graaddag"
  },
  "heat consumption": {
    "en": "Heat consumption",
    "nl": "Warmteverbruik"
  },
  "heat consumption per hdd": {
    "en": "Heat consumption per HDD",
    "nl": "Warmteverbruik per graaddag"
  },
  "heat consumption (estimated)": {
    "en": "Heat consumption (estimated)",
    "nl": "Warmteverbruik (geschat)"
  },
  "heat consumption tax": {
    "en": "Heat consumption tax",
    "nl": "Belasting op warmte"
  },
  "heating degree days": {
    "en": "Heating degree days",
    "nl": "Graaddagen"
  },
  "energy compass": {
    "en": "Energy compass",
    "nl": "Energiekompas"
  },
  "energy compass is loading": {
    "en": "Energy compass is loading",
    "nl": "Energiekompas wordt geladen"
  },
  "filter...": {
    "en": "Filter",
    "nl": "Filter"
  },
  "electricity production icon": {
    "en": "Electricity production icon",
    "nl": "Elektriciteitsproductie icoon"
  },
  "electricity feed-in icon": {
    "en": "Electricity feed-in icon",
    "nl": "Teruglevering icoon"
  },
  "zoom in": {
    "en": "Zoom in",
    "nl": "Inzoomen"
  },
  "zoom out": {
    "en": "Zoom out",
    "nl": "Uitzoomen"
  },
  "customize": {
    "en": "Customize",
    "nl": "Configureren"
  },
  "this month": {
    "en": "This month",
    "nl": "Deze maand"
  },
  "previous month": {
    "en": "Previous month",
    "nl": "Vorige maand"
  },
  "this year": {
    "en": "This year",
    "nl": "Dit jaar"
  },
  "previous year": {
    "en": "Previous year",
    "nl": "Vorig jaar"
  },
  "last 12 months": {
    "en": "Last 12 months",
    "nl": "Laatste 12 maanden"
  },
  "last week": {
    "en": "Last week",
    "nl": "Vorige week"
  },
  "custom range": {
    "en": "Custom range",
    "nl": "Aangepast bereik"
  },
  "all time": {
    "en": "All time",
    "nl": "Alles"
  },
  "measurement": {
    "en": "Measurement",
    "nl": "Meting"
  },
  "electricity reactive": {
    "en": "Electricity reactive",
    "nl": "Blindverbruik"
  },
  "electricity costs": {
    "en": "Electricity costs",
    "nl": "Elektriciteitskosten"
  },
  "gas costs": {
    "en": "Gas costs",
    "nl": "Gaskosten"
  },
  "water costs": {
    "en": "Water costs",
    "nl": "Waterkosten"
  },
  "heat costs": {
    "en": "Heat costs",
    "nl": "Warmtekosten"
  },
  "co² from electricity": {
    "en": "CO² from electricity",
    "nl": "CO² vanuit elektriciteit"
  },
  "co² from gas": {
    "en": "CO² from gas",
    "nl": "CO² vanuit gas"
  },
  "co² from water": {
    "en": "CO² from water",
    "nl": "CO² vanuit water"
  },
  "co² from heat": {
    "en": "CO² from heat",
    "nl": "CO² vanuit warmte"
  },
  "a JavaScript library for interactive maps": {
    "en": "A JavaScript library for interactive maps",
    "nl": "Een JavaScript-bibliotheek voor interactieve kaarten"
  },
  "split off-peak": {
    "en": "Peak and off-peak consumption",
    "nl": "Normaal- en dalverbruik"
  },
  "netted consumption": {
    "en": "Netted consumption",
    "nl": "Gesaldeerd verbruik"
  },
  "show reactive": {
    "en": "Reactive consumption",
    "nl": "Blindverbruik"
  },
  "compare with": {
    "en": "Compare with",
    "nl": "Vergelijken met"
  },
  "last year": {
    "en": "Last year",
    "nl": "Afgelopen jaar"
  },
  "maximum power": {
    "en": "Peak power",
    "nl": "Piekvermogen"
  },
  "filter": {
    "en": "Filter",
    "nl": "Filter"
  },
  "weather": {
    "en": "Weather",
    "nl": "Weer"
  },
  "temperature": {
    "en": "Temperature",
    "nl": "Temperatuur"
  },
  "sun hours": {
    "en": "Sun hours",
    "nl": "Zonuren"
  },
  "wind speed": {
    "en": "Wind speed",
    "nl": "Windsnelheid"
  },
  "rainfall": {
    "en": "Rainfall",
    "nl": "Neerslag"
  },
  "solar radiation": {
    "en": "Solar radiation",
    "nl": "Zonkracht"
  },
  "maximum power can only be shown per ean": {
    "en": "Peak power can only be shown per EAN",
    "nl": "Piekvermogen kan enkel per aansluiting worden getoond"
  },
  "no connections found within selection": {
    "en": "No connections found within selection",
    "nl": "Geen aansluitingen gevonden binnen de selectie"
  },
  "energy labels": {
    "en": "Energy labels",
    "nl": "Energielabels"
  },
  "show unknown": {
    "en": "Show unknown",
    "nl": "Toon onbekend"
  },
  "building": {
    "en": "Building",
    "nl": "Gebouw"
  },
  "building types": {
    "en": "Building types",
    "nl": "Gebouwtypes"
  },
  "energy label": {
    "en": "Energy label",
    "nl": "Energielabel"
  },
  "valid until": {
    "en": "Valid until",
    "nl": "Geldig tot"
  },
  "area": {
    "en": "Area",
    "nl": "Oppervlakte"
  },
  "building type": {
    "en": "Building type",
    "nl": "Gebouwtype"
  },
  "registration date": {
    "en": "Registration date",
    "nl": "Datum registratie"
  },
  "primary fossil energy": {
    "en": "Primary fossil energy",
    "nl": "Primair fossiel energiegebruik"
  },
  "energy demand": {
    "en": "Energy demand",
    "nl": "Energiebehoefte"
  },
  "renewable energy": {
    "en": "Renewable energy",
    "nl": "Hernieuwbare energie"
  },
  "energy index": {
    "en": "Energy index",
    "nl": "Energie-index"
  },
  "EP thermal-zone area": {
    "en": "EP thermal-zone area",
    "nl": "EP-oppervlakte thermische zone"
  },
  "year built": {
    "en": "Year built",
    "nl": "Bouwjaar"
  },
  "electricity meter": {
    "en": "Electricity meter",
    "nl": "Elektriciteitsmeter"
  },
  "gas/heat meter": {
    "en": "Gas/Heat meter",
    "nl": "Gas-/warmtemeter"
  },
  "electricity meters": {
    "en": "Electricity meters",
    "nl": "Elektriciteitsmeters"
  },
  "meters": {
    "en": "Meters",
    "nl": "Meters"
  },
  "correct meter data": {
    "en": "Correct meter data",
    "nl": "Meterdata corrigeren"
  },
  "no meters available for correction": {
    "en": "No meters available for correction",
    "nl": "Geen meters beschikbaar voor correctie"
  },
  "select the meter whose historical data should be corrected.": {
    "en": "Select the meter whose historical data should be corrected.",
    "nl": "Selecteer de meter waarvan de historische data moet worden gecorrigeerd."
  },
  "start correction": {
    "en": "Start correction",
    "nl": "Correctie starten"
  },
  "from": {
    "en": "From",
    "nl": "Vanaf"
  },
  "until": {
    "en": "Until",
    "nl": "Tot"
  },
  "the source data for this period will be retrieved again and existing measurements may be updated.": {
    "en": "The source data for this period will be retrieved again and existing measurements may be updated.",
    "nl": "De brondata voor deze periode wordt opnieuw opgehaald en bestaande meetwaarden kunnen worden bijgewerkt."
  },
  "meter data correction has been started": {
    "en": "Meter data correction has been started",
    "nl": "De correctie van de meterdata is gestart"
  },
  "gas/heat meters": {
    "en": "Gas/Heat meters",
    "nl": "Gas-/warmtemeters"
  },
  "sub meters": {
    "en": "Sub-meters",
    "nl": "Tussenmeters"
  },
  "water meters": {
    "en": "Water meters",
    "nl": "Watermeters"
  },
  "select a location to generate a quarterly report.": {
    "en": "Select a location to generate a quarterly report.",
    "nl": "Selecteer een locatie om een kwartaalrapport te genereren."
  },
  "no location selected": {
    "en": "No location selected",
    "nl": "Geen locatie geselecteerd"
  },
  "renewable fuel units": {
    "en": "Renewable fuel units",
    "nl": "Hernieuwbare Brandstof Eenheden (HBE's)"
  },
  "sub meter icon": {
    "en": "Sub-meter icon",
    "nl": "Tussenmeter icoon"
  },
  "electricity intermediate consumption": {
    "en": "Electricity sub-meter consumption",
    "nl": "Tussenmeterverbruik elektriciteit"
  },
  "electricity gross production": {
    "en": "Electricity gross production",
    "nl": "Bruto productie"
  },
  "electricity reactive gross production": {
    "en": "Electricity reactive gross production",
    "nl": "Blindverbruik bruto productie"
  },
  "gross_production": {
    "en": "Gross production",
    "nl": "Bruto productie"
  },
  "gross production": {
    "en": "Gross production",
    "nl": "Bruto productie"
  },
  "split by sub meters": {
    "en": "Sub-meters",
    "nl": "Tussenmeters"
  },
  "show consumption": {
    "en": "Show consumption",
    "nl": "Verbruiken"
  },
  "show feed-in": {
    "en": "Show feed-in",
    "nl": "Teruglevering"
  },
  "show production": {
    "en": "Production",
    "nl": "Productie"
  },
  "power data is unavailable for this connection": {
    "en": "Power data is unavailable for this connection",
    "nl": "Piekvermogendata ontbreekt bij deze aansluiting."
  },
  "contracted power is unknown for this connection": {
    "en": "Contracted power is unknown for this connection",
    "nl": "Gecontracteerd vermogen ontbreekt bij deze aansluiting."
  },
  "per m": {
    "en": "per m",
    "nl": "per m"
  },
  "per year": {
    "en": "per year",
    "nl": "per jaar"
  },
  "modify": {
    "en": "Modify",
    "nl": "Bewerken"
  },
  "account": {
    "en": "Account",
    "nl": "Account"
  },
  "general": {
    "en": "General",
    "nl": "Algemeen"
  },
  "security": {
    "en": "Security",
    "nl": "Beveiliging"
  },
  "first name": {
    "en": "First name",
    "nl": "Voornaam"
  },
  "last name": {
    "en": "Last name",
    "nl": "Achternaam"
  },
  "email": {
    "en": "Email",
    "nl": "E-mail"
  },
  "phone": {
    "en": "Phone",
    "nl": "Telefoonnummer"
  },
  "delete your account": {
    "en": "Delete your account",
    "nl": "Account verwijderen"
  },
  "please note, deleting your account is a permanent action and will not be recoverable once completed.": {
    "en": "Please note, deleting your account is a permanent action and will not be recoverable once completed.",
    "nl": "Houd er rekening mee dat het verwijderen van uw account een permanente actie is en niet kan worden hersteld als het eenmaal is voltooid."
  },
  "delete account": {
    "en": "Delete account",
    "nl": "Account verwijderen"
  },
  "please enter a first name": {
    "en": "Please enter a first name",
    "nl": "Voer een voornaam in"
  },
  "please enter a last name": {
    "en": "Please enter a last name",
    "nl": "Voer een achternaam in"
  },
  "please enter a phone": {
    "en": "Please enter a phone",
    "nl": "Voer een telefoonnummer in"
  },
  "telephone number": {
    "en": "Phone Number",
    "nl": "Telefoonnummer"
  },
  "remove item": {
    "en": "Delete item",
    "nl": "Item verwijderen"
  },
  "are you sure you want to remove this item?": {
    "en": "Are you sure you want to delete this item?",
    "nl": "Weet u zeker dat u dit item wilt verwijderen?"
  },
  "are you sure you want to remove this authorisation?": {
    "en": "Are you sure you want to delete this authorisation?",
    "nl": "Weet u zeker dat u deze machtiging wilt verwijderen?"
  },
  "remove connection": {
    "en": "Delete connection",
    "nl": "Aansluiting verwijderen"
  },
  "are you sure you want to remove this connection?": {
    "en": "Are you sure you want to delete this connection?",
    "nl": "Weet u zeker dat u deze aansluiting wilt verwijderen?"
  },
  "remove location": {
    "en": "Delete location",
    "nl": "Locatie verwijderen"
  },
  "are you sure you want to remove this location?": {
    "en": "Are you sure you want to delete this location?",
    "nl": "Weet u zeker dat u deze locatie wilt verwijderen?"
  },
  "delete user": {
    "en": "Delete user",
    "nl": "Gebruiker verwijderen"
  },
  "are you sure you want to delete this user?": {
    "en": "Are you sure you want to delete this user?",
    "nl": "Weet u zeker dat u deze gebruiker wilt verwijderen?"
  },
  "delete organisation": {
    "en": "Delete organisation",
    "nl": "Organisatie verwijderen"
  },
  "are you sure you want to delete this organisation?": {
    "en": "Are you sure you want to delete this organisation?",
    "nl": "Weet u zeker dat u deze organisatie wilt verwijderen?"
  },
  "delete account?": {
    "en": "Delete account?",
    "nl": "Account verwijderen?"
  },
  "are you sure you want to delete your user account? Deleting your account is permanent and will not be recoverable once completed.": {
    "en": "Are you sure you want to delete your user account? Deleting your account is permanent and will not be recoverable once completed.",
    "nl": "Weet u zeker dat u uw gebruikersaccount wil verwijderen? Het verwijderen van uw account is permanent en kan niet worden hersteld als het eenmaal is voltooid."
  },
  "confirm": {
    "en": "Confirm",
    "nl": "Bevestigen"
  },
  "change your password": {
    "en": "Change your password",
    "nl": "Wachtwoord wijzigigen"
  },
  "we will email you a confirmation when changing your password, so please expect that email after submitting.": {
    "en": "You will receive a confirmation email after saving your new password.",
    "nl": "U ontvangt een e-mail na het opslaan van uw nieuwe wachtwoord."
  },
  "forgot your password?": {
    "en": "Forgot your password?",
    "nl": "Wachtwoord vergeten?"
  },
  "password requirements": {
    "en": "Password requirements",
    "nl": "Wachtwoordvereisten"
  },
  "please ensure that your password is at least 8 characters long": {
    "en": "Your password must contain at least 8 characters",
    "nl": "Zorg ervoor dat uw wachtwoord minstens 8 tekens bevat"
  },
  "current password": {
    "en": "Current password",
    "nl": "Huidige wachtwoord"
  },
  "update password": {
    "en": "Save password",
    "nl": "Wachtwoord opslaan"
  },
  "new password": {
    "en": "New password",
    "nl": "Nieuw wachtwoord"
  },
  "(optional)": {
    "en": "(optional)",
    "nl": "(optioneel)"
  },
  "chamber of commerce number": {
    "en": "Chamber of commerce number",
    "nl": "KVK-nummer"
  },
  "dd-mm-yyyy": {
    "en": "dd-mm-yyyy",
    "nl": "dd-mm-jjjj"
  },
  "intermediary": {
    "en": "Intermediary",
    "nl": "Intermediair"
  },
  "owner": {
    "en": "Owner",
    "nl": "Hoofdbeheerder"
  },
  "manager": {
    "en": "Manager",
    "nl": "Beheerder"
  },
  "viewer": {
    "en": "Viewer",
    "nl": "Bekijker"
  },
  "name": {
    "en": "Name",
    "nl": "Naam"
  },
  "revoke": {
    "en": "Revoke",
    "nl": "Intrekken"
  },
  "revoked": {
    "en": "Revoked",
    "nl": "Ingetrokken"
  },
  "active": {
    "en": "Active",
    "nl": "Actief"
  },
  "add location": {
    "en": "Add location",
    "nl": "Locatie toevoegen"
  },
  "organisation": {
    "en": "Organisation",
    "nl": "Organisatie"
  },
  "details": {
    "en": "Details",
    "nl": "Details"
  },
  "add authorisation": {
    "en": "Add authorisation",
    "nl": "Autorisatie toevoegen"
  },
  "download": {
    "en": "Download",
    "nl": "Downloaden"
  },
  "upload": {
    "en": "Upload",
    "nl": "Uploaden"
  },
  "language": {
    "en": "Language",
    "nl": "Taal"
  },
  "dutch": {
    "en": "Dutch",
    "nl": "Nederlands"
  },
  "english": {
    "en": "English",
    "nl": "Engels"
  },
  "add connection": {
    "en": "Add connection",
    "nl": "Aansluiting toevoegen"
  },
  "sign in": {
    "en": "Sign in",
    "nl": "Log in"
  },
  "for access to your dashboard.": {
    "en": "For access to your dashboard.",
    "nl": "Voor toegang tot uw dashboard."
  },
  "email address": {
    "en": "Email address",
    "nl": "E-mailadres"
  },
  "forgot password?": {
    "en": "Forgot password?",
    "nl": "Wachtwoord vergeten?"
  },
  "enter your password": {
    "en": "Enter your password",
    "nl": "Voer uw wachtwoord in"
  },
  "please enter an email address": {
    "en": "Please enter an email address",
    "nl": "Voer een e-mailadres in"
  },
  "please enter a password": {
    "en": "Please enter a password",
    "nl": "Voer een wachtwoord in"
  },
  "password": {
    "en": "Password",
    "nl": "Wachtwoord"
  },
  "sign up": {
    "en": "Sign up",
    "nl": "Registreren"
  },
  "don't have an account yet?": {
    "en": "Don't have an account yet?",
    "nl": "Nog geen account?"
  },
  "already have an account?": {
    "en": "Already have an account?",
    "nl": "Heeft u al een account?"
  },
  "reset password": {
    "en": "Reset password",
    "nl": "Reset wachtwoord"
  },
  "please check your inbox at the e-mail address you provided for a confirmation code to reset your password.": {
    "en": "Please check your inbox at the e-mail address you provided for the confirmation code to reset your password.",
    "nl": "Controleer uw inbox op het door u opgegeven e-mailadres voor de bevestigingscode om uw wachtwoord opnieuw in te stellen."
  },
  "password reset": {
    "en": "Password reset",
    "nl": "Wachtwoord resetten"
  },
  "enter your email to get a password reset link.": {
    "en": "Enter your email to get a password reset link.",
    "nl": "Voer uw e-mailadres in om een link te ontvangen voor het instellen van uw wachtwoord."
  },
  "remember your password?": {
    "en": "Remember your password?",
    "nl": "Weet u uw wachtwoord weer?"
  },
  "log in": {
    "en": "Log in",
    "nl": "Log in"
  },
  "confirmation code": {
    "en": "Confirmation code",
    "nl": "Toegangscode"
  },
  "did you not receive the confirmation e-mail? check your spam folder, or": {
    "en": "Did you not receive the confirmation e-mail? Check your spam folder or",
    "nl": "Heeft u de bevestigingsmail niet ontvangen? Controleer uw spam of"
  },
  "request a password reset again": {
    "en": "request a password reset again",
    "nl": "vraag nogmaals een wachtwoord reset aan"
  },
  "location": {
    "en": "Location",
    "nl": "Locatie"
  },
  "new authorisation": {
    "en": "New authorisation",
    "nl": "Nieuwe machtiging"
  },
  "please enter a type": {
    "en": "Please enter a type",
    "nl": "Voer een type in"
  },
  "please enter a role": {
    "en": "Please enter a role",
    "nl": "Voer een rol in"
  },
  "please enter a start": {
    "en": "Please enter a start date",
    "nl": "Voer een startdatum in"
  },
  "please enter an end": {
    "en": "Please enter an end date",
    "nl": "Voer een eindedatum in"
  },
  "please enter a connection": {
    "en": "Please enter a connection",
    "nl": "Voer een aansluiting in"
  },
  "cancel": {
    "en": "Cancel",
    "nl": "Annuleren"
  },
  "search for a connection": {
    "en": "Search for a connection",
    "nl": "Zoek naar een aansluiting"
  },
  "connection": {
    "en": "Connection",
    "nl": "Aansluiting"
  },
  "type": {
    "en": "Type",
    "nl": "Type"
  },
  "role": {
    "en": "Role",
    "nl": "Rol"
  },
  "start": {
    "en": "Start",
    "nl": "Start"
  },
  "end": {
    "en": "End",
    "nl": "Einde"
  },
  "location details": {
    "en": "Location details",
    "nl": "Locatiegegevens"
  },
  "please enter a name": {
    "en": "Please enter a name",
    "nl": "Voer een naam in"
  },
  "building code": {
    "en": "Object name",
    "nl": "Objectnaam"
  },
  "please enter a building code": {
    "en": "Please enter a object name",
    "nl": "Voer een objectnaam in"
  },
  "department": {
    "en": "Department",
    "nl": "Afdeling"
  },
  "please enter a department": {
    "en": "Please enter a department",
    "nl": "Voer een afdeling in"
  },
  "please enter an energy label": {
    "en": "Please enter an energy label",
    "nl": "Voer een energielabel in"
  },
  "object number": {
    "en": "Object number",
    "nl": "Objectnummer"
  },
  "bag addressable object id": {
    "en": "BAG addressable object ID",
    "nl": "Verblijfsobject ID"
  },
  "fully electric building": {
    "en": "Fully electric building",
    "nl": "Volledig elektrisch pand"
  },
  "yes": {
    "en": "Yes",
    "nl": "Ja"
  },
  "no": {
    "en": "No",
    "nl": "Nee"
  },
  "don't forget to save": {
    "en": "don't forget to save",
    "nl": "vergeet niet op te slaan"
  },
  "ep-online connection verified": {
    "en": "EP-Online connection verified",
    "nl": "EP-Online-koppeling geverifieerd"
  },
  "bag id ready to be checked": {
    "en": "BAG ID ready to be checked",
    "nl": "BAG-ID gereed om te controleren"
  },
  "please enter a bag addressable object id": {
    "en": "Please enter a valid 16-digit BAG addressable object ID",
    "nl": "Vul een geldig 16-cijferig BAG-verblijfsobject-ID in"
  },
  "enter the 16-digit bag addressable object id so ep-online can retrieve the corresponding energy-label data. if left blank, the system will try to find it automatically using the postcode and house number. a green check mark means the connection has been established.": {
    "en": "Enter the 16-digit BAG addressable object ID so EP-Online can retrieve the corresponding energy-label data. If left blank, the system will try to find it automatically using the postcode and house number. A green check mark means the connection has been established.",
    "nl": "Vul het 16-cijferige BAG-verblijfsobject-ID in, zodat EP-Online de bijbehorende energielabelgegevens kan ophalen. Als je dit veld leeg laat, probeert het systeem de gegevens automatisch te vinden op basis van postcode en huisnummer. Een groen vinkje betekent dat de koppeling tot stand is gebracht."
  },
  "location image": {
    "en": "Location image",
    "nl": "Locatieafbeelding"
  },
  "shown on the cover page of the location reports. supported file types: jpg, png, webp. maximum file size: 2 mb.": {
    "en": "Shown on the cover page of the location reports. Supported file types: JPG, PNG, WebP. Maximum file size: 2 MB.",
    "nl": "Wordt getoond op het voorblad van de locatierapportages. Ondersteunde bestandstypen: JPG, PNG, WebP. Maximale bestandsgrootte: 2 MB."
  },
  "no image selected": {
    "en": "No image selected",
    "nl": "Geen afbeelding geselecteerd"
  },
  "select image": {
    "en": "Select image",
    "nl": "Afbeelding selecteren"
  },
  "replace image": {
    "en": "Replace image",
    "nl": "Afbeelding vervangen"
  },
  "only jpg, png and webp images are supported.": {
    "en": "Only JPG, PNG and WebP images are supported.",
    "nl": "Alleen JPG-, PNG- en WebP-afbeeldingen worden ondersteund."
  },
  "the image must be 2 mb or smaller.": {
    "en": "The image must be 2 MB or smaller.",
    "nl": "De afbeelding mag maximaal 2 MB zijn."
  },
  "please enter an object number": {
    "en": "Please enter an object number",
    "nl": "Voer een objectnummer in"
  },
  "address": {
    "en": "Address",
    "nl": "Adres"
  },
  "street": {
    "en": "Street",
    "nl": "Straat"
  },
  "please enter a street": {
    "en": "Please enter a street",
    "nl": "Voer een straat in"
  },
  "house number": {
    "en": "House number",
    "nl": "Huisnummer"
  },
  "please enter a house number": {
    "en": "Please enter a house number",
    "nl": "Voer een huisnummer in"
  },
  "addition": {
    "en": "Addition",
    "nl": "Toevoeging"
  },
  "please enter a addition": {
    "en": "Please enter a addition",
    "nl": "Voer een toevoeging in"
  },
  "zipcode": {
    "en": "Zipcode",
    "nl": "Postcode"
  },
  "please enter a zipcode": {
    "en": "Please enter a zipcode",
    "nl": "Voer een postcode in"
  },
  "city": {
    "en": "City",
    "nl": "Plaatsnaam"
  },
  "please enter a city": {
    "en": "Please enter a city",
    "nl": "Voer een plaatsnaam in"
  },
  "country": {
    "en": "Country",
    "nl": "Land"
  },
  "please enter a country": {
    "en": "Please enter a country",
    "nl": "Voer een land in"
  },
  "su": {
    "en": "Su",
    "nl": "Zo"
  },
  "sa": {
    "en": "Sa",
    "nl": "Za"
  },
  "fr": {
    "en": "Fr",
    "nl": "Vr"
  },
  "th": {
    "en": "Th",
    "nl": "Do"
  },
  "we": {
    "en": "We",
    "nl": "Wo"
  },
  "tu": {
    "en": "Tu",
    "nl": "Di"
  },
  "mo": {
    "en": "Mo",
    "nl": "Ma"
  },
  "save": {
    "en": "Save",
    "nl": "Opslaan"
  },
  "close": {
    "en": "Close",
    "nl": "Sluiten"
  },
  "january": {
    "en": "January",
    "nl": "Januari"
  },
  "february": {
    "en": "February",
    "nl": "Februari"
  },
  "march": {
    "en": "March",
    "nl": "Maart"
  },
  "april": {
    "en": "April",
    "nl": "April"
  },
  "may": {
    "en": "May",
    "nl": "Mei"
  },
  "june": {
    "en": "June",
    "nl": "Juni"
  },
  "july": {
    "en": "July",
    "nl": "Juli"
  },
  "august": {
    "en": "August",
    "nl": "Augustus"
  },
  "september": {
    "en": "September",
    "nl": "September"
  },
  "october": {
    "en": "October",
    "nl": "Oktober"
  },
  "november": {
    "en": "November",
    "nl": "November"
  },
  "december": {
    "en": "December",
    "nl": "December"
  },
  "if you switch away from the editing screen, you will lose all the changes you have made.": {
    "en": "If you switch away from the editing screen, you will lose all the changes you have made.",
    "nl": "Als u dit scherm verlaat, gaan alle wijzigingen die u heeft aangebracht verloren."
  },
  "continue editing": {
    "en": "Continue editing",
    "nl": "Doorgaan met bewerken"
  },
  "close without saving": {
    "en": "Close without saving",
    "nl": "Sluiten zonder opslaan"
  },
  "very uneconomical": {
    "en": "Very uneconomical",
    "nl": "Zeer onzuinig"
  },
  "uneconomical": {
    "en": "Uneconomical",
    "nl": "Onzuinig"
  },
  "average": {
    "en": "Average",
    "nl": "Gemiddeld"
  },
  "economical": {
    "en": "Economical",
    "nl": "Zuinig"
  },
  "very economical": {
    "en": "Very economical",
    "nl": "Zeer zuinig"
  },
  "paris proof": {
    "en": "Paris Proof",
    "nl": "Parijs Akkoord"
  },
  "weng": {
    "en": "WENG",
    "nl": "WENG"
  },
  "period": {
    "en": "Period",
    "nl": "Periode"
  },
  "current period": {
    "en": "Current period",
    "nl": "Huidige periode"
  },
  "year": {
    "en": "Year",
    "nl": "Jaar"
  },
  "month": {
    "en": "Month",
    "nl": "Maand"
  },
  "day": {
    "en": "Day",
    "nl": "Dag"
  },
  "hour": {
    "en": "Hour",
    "nl": "Uur"
  },
  "minute": {
    "en": "Quarter-hour",
    "nl": "Kwartier"
  },
  "contracted power": {
    "en": "Contracted power",
    "nl": "Gecontracteerd vermogen"
  },
  "contracted feed-in power": {
    "en": "Contracted feed-in power",
    "nl": "Gecontracteerd terugleververmogen"
  },
  "electricity power": {
    "en": "Peak power",
    "nl": "Piekvermogen"
  },
  "electricity feed-in power": {
    "en": "Peak feed-in power",
    "nl": "Piekvermogen (teruglevering)"
  },
  "peak power (gtv-t)": {
    "en": "Peak power (GTV-T)",
    "nl": "Piekvermogen (GTV-T)"
  },
  "gas power": {
    "en": "Peak power (gas)",
    "nl": "Piekvermogen (gas)"
  },
  "water power": {
    "en": "Peak power",
    "nl": "Piekvermogen"
  },
  "heat power": {
    "en": "Peak power (heat)",
    "nl": "Piekvermogen (warmte)"
  },
  "show per m²": {
    "en": "Show per m²",
    "nl": "Toon per m²"
  },
  "per m²": {
    "en": "per m²",
    "nl": "per m²"
  },
  "delete": {
    "en": "Delete",
    "nl": "Verwijderen"
  },
  "delete dashboard": {
    "en": "Delete dashboard?",
    "nl": "Dashboard verwijderen?"
  },
  "are you sure you want to delete this dashboard?": {
    "en": "Are you sure you want to delete this dashboard?",
    "nl": "Weet u zeker dat u dit dashboard wil verwijderen?"
  },
  "save report": {
    "en": "Schedule report",
    "nl": "Rapport inplannen"
  },
  "delete report?": {
    "en": "Delete report?",
    "nl": "Rapport verwijderen?"
  },
  "are you sure you want to delete this report? This will cancel any further emails.": {
    "en": "Are you sure you want to delete this report? This will also cancel any scheduled reports.",
    "nl": "Weet u zeker dat u dit rapport wil verwijderen? Hiermee worden tevens geplande rapportages geannuleerd."
  },
  "sources": {
    "en": "Selection",
    "nl": "Selectie"
  },
  "duration": {
    "en": "Period",
    "nl": "Periode"
  },
  "opening hoyrs": {
    "en": "Opening hours",
    "nl": "Openingsuren"
  },
  "annual comparison per month": {
    "en": "Annual comparison per month",
    "nl": "Jaarvergelijking per maand"
  },
  "monthly comparison per day": {
    "en": "Monthly comparison per day",
    "nl": "Maandvergelijking per dag"
  },
  "weekly comparison per day": {
    "en": "Weekly comparison per day",
    "nl": "Weekvergelijking per dag"
  },
  "daily comparison per hour": {
    "en": "Daily comparison per hour",
    "nl": "Dagvergelijking per uur"
  },
  "user": {
    "en": "User",
    "nl": "Gebruiker"
  },
  "executed on": {
    "en": "Report date",
    "nl": "Rapportdatum"
  },
  "time range": {
    "en": "Period",
    "nl": "Periode"
  },
  "frequency": {
    "en": "Frequency",
    "nl": "Frequentie"
  },
  "never": {
    "en": "Not repeated",
    "nl": "Niet herhaald"
  },
  "yearly": {
    "en": "Each year",
    "nl": "Elk jaar"
  },
  "monthly": {
    "en": "Each month",
    "nl": "Elke maand"
  },
  "weekly": {
    "en": "Each week",
    "nl": "Elke week"
  },
  "daily": {
    "en": "Each day",
    "nl": "Elke dag"
  },
  "yearly scheduled": {
    "en": "Scheduled yearly",
    "nl": "Jaarlijks gepland"
  },
  "monthly scheduled": {
    "en": "Scheduled monthly",
    "nl": "Maandelijks gepland"
  },
  "weekly scheduled": {
    "en": "Scheduled weekly",
    "nl": "Wekelijks gepland"
  },
  "daily scheduled": {
    "en": "Scheduled daily",
    "nl": "Dagelijks gepland"
  },
  "co² emissions": {
    "en": "CO² emissions",
    "nl": "CO²-uitstoot"
  },
  "co² emission": {
    "en": "CO² emission",
    "nl": "CO²-uitstoot"
  },
  "primary": {
    "en": "Primary meter",
    "nl": "Primaire meter"
  },
  "intermediate": {
    "en": "Sub-meter",
    "nl": "Tussenmeter"
  },
  "meter information": {
    "en": "Meter details",
    "nl": "Metergegevens"
  },
  "meter type": {
    "en": "Meter type",
    "nl": "Metertype"
  },
  "meter name": {
    "en": "Meter name",
    "nl": "Meternaam"
  },
  "covered area": {
    "en": "Covered area",
    "nl": "Overdekt gebied"
  },
  "categories": {
    "en": "Categories",
    "nl": "Categorieën"
  },
  "filters": {
    "en": "Filters",
    "nl": "Filters"
  },
  "show submeters as": {
    "en": "Show submeters as",
    "nl": "Toon tussenmeters als"
  },
  "meter": {
    "en": "Meter",
    "nl": "Meter"
  },
  "parent meter": {
    "en": "Parent meter",
    "nl": "Bovenliggende meter"
  },
  "share of main meter": {
    "en": "Share of main meter",
    "nl": "Aandeel van hoofdmeter"
  },
  "share of parent": {
    "en": "Share of parent",
    "nl": "Aandeel van bovenliggende meter"
  },
  "virtual breakdown": {
    "en": "Virtual breakdown",
    "nl": "Virtuele doorsnede"
  },
  "this virtual breakdown overlaps the physical meter flow and is not added to the total.": {
    "en": "This virtual breakdown overlaps the physical meter flow and is not added to the total.",
    "nl": "Deze virtuele doorsnede overlapt de fysieke meterstroom en wordt niet bij het totaal opgeteld."
  },
  "the meters in this split exceed their parent. flow shares are scaled to prevent double counting.": {
    "en": "The meters in this split exceed their parent. Flow shares are scaled to prevent double counting.",
    "nl": "De meters in deze verdeling zijn samen groter dan hun bovenliggende meter. De stroomaandelen zijn geschaald om dubbeltelling te voorkomen."
  },
  "floor": {
    "en": "Floor",
    "nl": "Etage"
  },
  "tower": {
    "en": "Tower",
    "nl": "Toren"
  },
  "tenant": {
    "en": "Tenant",
    "nl": "Huurder"
  },
  "custom": {
    "en": "Add your own category",
    "nl": "Voeg uw eigen categorie toe"
  },
  "custom category": {
    "en": "Custom category",
    "nl": "Eigen categorie"
  },
  "add category": {
    "en": "Add category",
    "nl": "Categorie toevoegen"
  },
  "category": {
    "en": "Category",
    "nl": "Categorie"
  },
  "value": {
    "en": "Value",
    "nl": "Waarde"
  },
  "select category": {
    "en": "Select category",
    "nl": "Selecteer categorie"
  },
  "no electricity consumption data available for this location": {
    "en": "No electricity consumption data available for this location",
    "nl": "Geen electriciteitsverbruik data beschikbaar op deze locatie"
  },
  "contracted capacity": {
    "en": "Contracted power",
    "nl": "Gecontracteerd vermogen"
  },
  "contracted feed-in capacity": {
    "en": "Contracted feed-in power",
    "nl": "Gecontracteerd vermogen (teruglevering)"
  },
  "connection value": {
    "en": "Connection value",
    "nl": "Aansluitwaarde"
  },
  "contracted capacity can be changed by selecting the correct connection value": {
    "en": "Contracted capacity can be changed by selecting the correct connection value",
    "nl": "Gecontracteerd vermogen kan aangepast worden door de juiste aansluitwaarde te selecteren"
  },
  "show uncorrected gas consumption": {
    "en": "Show uncorrected gas consumption",
    "nl": "Toon ongecorrigeerd gasverbruik"
  },
  "show by m²": {
    "en": "Show by m²",
    "nl": "Toon per m²"
  },
  "this building has no known energy label": {
    "en": "This building has no known energy label",
    "nl": "Van dit gebouw is het energie label niet bekend"
  },
  "geo location": {
    "en": "Geo location",
    "nl": "Geolocatie"
  },
  "latitude": {
    "en": "Latitude",
    "nl": "Breedtegraad"
  },
  "longitude": {
    "en": "Longitude",
    "nl": "Lengtegraad"
  },
  "please enter an area": {
    "en": "Please enter an area",
    "nl": "Voer een gebied in"
  },
  "please enter a latitude": {
    "en": "Please enter a latitude",
    "nl": "Voer een breedtegraad in"
  },
  "please enter a longitude": {
    "en": "Please enter a longitude",
    "nl": "Voer een lengtegraad in"
  },
  "shop without goods refrigeration": {
    "en": "Shop without goods refrigeration",
    "nl": "Winkel zonder warenkoeling"
  },
  "hospital": {
    "en": "Hospital",
    "nl": "Ziekenhuis"
  },
  "other": {
    "en": "Other",
    "nl": "Overig"
  },
  "holiday park": {
    "en": "Holiday park",
    "nl": "Vakantiepark"
  },
  "daycare without overnight stay": {
    "en": "Daycare without overnight stay",
    "nl": "Opvang zonder overnachting"
  },
  "office": {
    "en": "Office",
    "nl": "Kantoor"
  },
  "university/higher vocational training/intermediate vocational training": {
    "en": "University/Higher vocational training/Intermediate vocational training",
    "nl": "Universiteit/HBO/MBO"
  },
  "car garage/showroom": {
    "en": "Car garage/showroom",
    "nl": "Garage/showroom"
  },
  "shop with goods refrigeration": {
    "en": "Shop with goods refrigeration",
    "nl": "Winkel met warenkoeling"
  },
  "café": {
    "en": "Café",
    "nl": "Café"
  },
  "childcare": {
    "en": "Childcare",
    "nl": "Kinderopvang"
  },
  "care home with overnight stay": {
    "en": "Care home with overnight stay",
    "nl": "Tehuis met overnachting"
  },
  "swimming pool": {
    "en": "Swimming pool",
    "nl": "Zwembad"
  },
  "sauna": {
    "en": "Sauna",
    "nl": "Sauna"
  },
  "cold store": {
    "en": "Cold store",
    "nl": "Koel/vrieshuis"
  },
  "production hall": {
    "en": "Production hall",
    "nl": "Bedrijfshal"
  },
  "cell building": {
    "en": "Cell building",
    "nl": "Cellengebouw"
  },
  "medical (group) practice": {
    "en": "Medical (group) practice",
    "nl": "Medische (groeps) praktijk"
  },
  "outdoor sports facilities": {
    "en": "Outdoor sports facilities",
    "nl": "Sportaccommodatie buiten"
  },
  "indoor sports accommodation": {
    "en": "Indoor sports accommodation",
    "nl": "Sportaccommodatie binnen"
  },
  "primary / secondary education": {
    "en": "Primary / Secondary education",
    "nl": "Basis/ Voorgezet onderwijs"
  },
  "restaurant": {
    "en": "Restaurant",
    "nl": "Restaurant"
  },
  "hotel": {
    "en": "Hotel",
    "nl": "Hotel"
  },
  "apartment building": {
    "en": "Apartment building",
    "nl": "Appartementengebouw"
  },
  "single house – apartment": {
    "en": "Single house – apartment",
    "nl": "Enkele woning – appartement"
  },
  "single house – ground-level": {
    "en": "Single house – ground-level",
    "nl": "Enkele woning – grondgebonden"
  },
  "are you sure you want to revoke the authorisation for": {
    "en": "Are you sure you want to revoke the authorisation for",
    "nl": "Weet u zeker dat u de machtiging wilt intrekken voor"
  },
  "revoke authorisation": {
    "en": "Revoke authorisation",
    "nl": "Machtiging intrekken"
  },
  "operation has completed successfully": {
    "en": "Operation has completed successfully",
    "nl": "Actie is geslaagd"
  },
  "confirm user account": {
    "en": "Confirm user account",
    "nl": "Account bevestigen"
  },
  "please check your inbox at the e-mail address you provided to confirm your account.": {
    "en": "Please check your inbox at the e-mail address you provided to confirm your account.",
    "nl": "Controleer uw inbox op het door u opgegeven e-mailadres om uw account te bevestigen."
  },
  "resend the confirmation e-mail": {
    "en": "resend the confirmation e-mail",
    "nl": "zend de bevestigingsmail nogmaals"
  },
  "or": {
    "en": "or",
    "nl": "of"
  },
  "go back to login page": {
    "en": "go back to login page",
    "nl": "ga terug naar inlogpagina"
  },
  "please check your inbox at the e-mail address you provided to reset your password.": {
    "en": "Please check your inbox at the e-mail address you provided to reset your password.",
    "nl": "Controleer uw inbox op het door u opgegeven e-mailadres om uw wachtwoord te wijzigen."
  },
  "did you not receive an e-mail with a password reset link? check your spam folder, or": {
    "en": "Did you not receive the password reset e-mail? Check your spam folder or",
    "nl": "Heeft u de reset e-mail niet ontvangen? Controleer uw spam of"
  },
  "deselect all": {
    "en": "Deselect all",
    "nl": "Deselecteer alle regels"
  },
  "select all": {
    "en": "Select all",
    "nl": "Selecteer alle regels"
  },
  "selected": {
    "en": "selected",
    "nl": "geselecteerd"
  },
  "select interval": {
    "en": "Select interval",
    "nl": "Selecteer interval"
  },
  "please select at least 1 record": {
    "en": "Please select at least 1 record",
    "nl": "Selecteer ten minste 1 regel"
  },
  "measurement data": {
    "en": "Measurement data",
    "nl": "Meetdata"
  },
  "send frequency": {
    "en": "Send frequency",
    "nl": "Ontvangstfrequentie"
  },
  "no area defined, consumption per m² is unavailable": {
    "en": "No area defined, consumption per m² is unavailable",
    "nl": "Geen oppervlakte opgegeven, verbruik per m² is niet beschikbaar"
  },
  "select one of the predefined period options": {
    "en": "Select one of the predefined 'Period' options",
    "nl": "Selecteer één van de vooraf gedefinieerde 'Periode' opties"
  },
  "other range": {
    "en": "Other range",
    "nl": "Andere periode"
  },
  "create user": {
    "en": "Create user",
    "nl": "Gebruiker aanmaken"
  },
  "add user": {
    "en": "Add user",
    "nl": "Gebruiker toevoegen"
  },
  "new user": {
    "en": "New user",
    "nl": "Nieuwe gebruiker"
  },
  "users": {
    "en": "Users",
    "nl": "Gebruikers"
  },
  "send welcome email": {
    "en": "Send welcome email",
    "nl": "Welkomstmail versturen"
  },
  "stop impersonating": {
    "en": "Stop impersonating",
    "nl": "Stop met imiteren gebruiker"
  },
  "impersonate user": {
    "en": "Impersonate user",
    "nl": "Gebruiker imiteren"
  },
  "latest login:": {
    "en": "Latest login:",
    "nl": "Laatst ingelogd:"
  },
  "no gross production meter available": {
    "en": "No gross production meter available",
    "nl": "Geen bruto productie meter aanwezig"
  },
  "no charge point data linked": {
    "en": "No charge point data linked",
    "nl": "Geen laadpaaldata gekoppeld"
  },
  "recipients": {
    "en": "Recipients",
    "nl": "Ontvangers"
  },
  "receive monthly report": {
    "en": "Receive monthly report",
    "nl": "Maandelijks rapport ontvangen"
  },
  "no data to show": {
    "en": "No data to show",
    "nl": "Er zijn geen gegevens om te tonen"
  },
  "consumption": {
    "en": "Consumption",
    "nl": "Verbruik"
  },
  "gas vs outdoor temperature": {
    "en": "Gas vs outdoor temperature",
    "nl": "Gasverbruik vs buitentemperatuur"
  },
  "heat vs outdoor temperature": {
    "en": "Heat consumption vs outdoor temperature",
    "nl": "Warmteverbruik vs buitentemperatuur"
  },
  "gas/heat vs outdoor temperature": {
    "en": "Gas/heat vs outdoor temperature",
    "nl": "Gas/warmte vs buitentemperatuur"
  },
  "split by opening hours": {
    "en": "Split by opening hours",
    "nl": "Splits op openingstijden"
  },
  "opening hours": {
    "en": "Opening hours",
    "nl": "Openingstijden"
  },
  "outside opening hours": {
    "en": "Outside opening hours",
    "nl": "Buiten openingstijden"
  },
  "outdoor temperature (°c)": {
    "en": "Outdoor temperature (°C)",
    "nl": "Buitentemperatuur (°C)"
  },
  "consumption (m³/h)": {
    "en": "Consumption (m³/h)",
    "nl": "Verbruik (m³/h)"
  },
  "consumption (m³/day)": {
    "en": "Consumption (m³/day)",
    "nl": "Verbruik (m³/dag)"
  },
  "show hourly data": {
    "en": "Show hourly data",
    "nl": "Toon per uur"
  },
  "month average": {
    "en": "Monthly average",
    "nl": "Maandgemiddelde"
  },
  "calculated from monthly data": {
    "en": "Calculated from monthly data",
    "nl": "Berekend uit maanddata"
  },
  "daily values are calculated": {
    "en": "Daily values are calculated",
    "nl": "Dagwaarden zijn berekend"
  },
  "20% base consumption, 80% distributed based on outdoor temperature": {
    "en": "20% base consumption, 80% distributed based on outdoor temperature",
    "nl": "20% basisverbruik, 80% verdeeld op basis van buitentemperatuur"
  },
  "no hourly data available": {
    "en": "No hourly data available",
    "nl": "Geen uurdata beschikbaar"
  },
  "m³/hour": {
    "en": "m³/hour",
    "nl": "m³/uur"
  },
  "m³/day": {
    "en": "m³/day",
    "nl": "m³/dag"
  },
  "split by weekdays/weekend": {
    "en": "Split by weekdays/weekend",
    "nl": "Splitsen op weekdagen/weekend"
  },
  "weekdays": {
    "en": "Weekdays",
    "nl": "Weekdagen"
  },
  "weekend": {
    "en": "Weekend",
    "nl": "Weekend"
  },
  "not available due to limited measurement data": {
    "en": "Not available due to limited measurement data",
    "nl": "Niet beschikbaar vanwege beperkte meetdata"
  },
  "no data available for this period": {
    "en": "No data available for this period",
    "nl": "Geen data beschikbaar voor deze periode"
  },
  "estimated": {
    "en": "Estimated",
    "nl": "Geschat"
  },
  "removed connection or location": {
    "en": "Removed connection or location",
    "nl": "Aansluiting of locatie verwijderd"
  },
  "connection monthly data template": {
    "en": "Connection monthly data template",
    "nl": "Data upload sjabloon (maandelijks)"
  },
  "raw connection data template": {
    "en": "Raw connection data template",
    "nl": "Data upload sjabloon (ruwe data)"
  },
  "monthly connection data": {
    "en": "Monthly connection data",
    "nl": "Connectie data (maandelijks)"
  },
  "raw connection data": {
    "en": "Raw connection data",
    "nl": "Connectie data (ruwe data)"
  },
  "monthly measurement data": {
    "en": "Monthly measurement data",
    "nl": "Maandverbruik"
  },
  "monthly measurement data (detailed)": {
    "en": "Monthly measurement data (detailed)",
    "nl": "Maandverbruik – gedetailleerd"
  },
  "monthly submeter data": {
    "en": "Monthly submeter data",
    "nl": "Tussenmeterverbruik"
  },
  "completeness": {
    "en": "Completeness",
    "nl": "Data compleetheid"
  },
  "total completeness for": {
    "en": "Total completeness for",
    "nl": "Totale data compleetheid voor"
  },
  "merge locations": {
    "en": "Merge locations",
    "nl": "Locaties samenvoegen"
  },
  "you are about to merge location": {
    "en": "You are about to merge location",
    "nl": "Je staat op het punt om de locatie"
  },
  "into": {
    "en": "into",
    "nl": "samen te voegen met"
  },
  "are you sure you want to move all connections to": {
    "en": "Are you sure you want to move all connections to",
    "nl": "Weet je zeker dat je alle connecties wilt overzetten naar"
  },
  "this cannot be undone!": {
    "en": "This cannot be undone!",
    "nl": "Deze wijziging is permanent en kan niet ongedaan gemaakt worden!"
  },
  "search for an organisation": {
    "en": "Search for an organisation",
    "nl": "Zoek naar een organisatie"
  },
  "add new authorisation": {
    "en": "Add new authorisation",
    "nl": "Voeg een machtiging toe"
  },
  "add new solaredge meter": {
    "en": "Add SolarEdge meter",
    "nl": "SolarEdge meter toevoegen"
  },
  "access point id": {
    "en": "Access point id",
    "nl": "Meter ophaalnummer"
  },
  "add solar edge meter": {
    "en": "Add SolarEdge meter",
    "nl": "Voeg een SolarEdge meter toe"
  },
  "site id": {
    "en": "Meter id",
    "nl": "Meternummer"
  },
  "kiosk url": {
    "en": "SolarEdge link",
    "nl": "SolarEdge link"
  },
  "api key": {
    "en": "API key",
    "nl": "API key"
  },
  "only needed for the legacy solaredge api. the new api uses the centrally configured fleet api key. do not enter that key here. leave this field blank to keep an existing legacy key.": {
    "en": "Only needed for the legacy SolarEdge API. The new API uses the centrally configured fleet API key. Do not enter that key here. Leave this field blank to keep an existing legacy key.",
    "nl": "Alleen nodig voor de oude SolarEdge API. De nieuwe API gebruikt de centraal ingestelde fleet-API-sleutel. Vul die hier niet in. Laat dit veld leeg om een bestaande sleutel voor de oude API te behouden."
  },
  "an api key is required for the legacy solaredge api": {
    "en": "An API key is required for the legacy SolarEdge API",
    "nl": "Voor de oude SolarEdge API is een API-sleutel nodig"
  },
  "remove meter": {
    "en": "Remove meter",
    "nl": "Meter verwijderen"
  },
  "are you sure you want to remove this meter?": {
    "en": "Are you sure you want to remove this meter?",
    "nl": "Weet je zeker dat je deze meter wilt verwijderen?"
  },
  "meter authorisation periods": {
    "en": "Meter authorisation periods",
    "nl": "Meter machtigingperiodes"
  },
  "meter list": {
    "en": "Meter list",
    "nl": "Meterlijst"
  },
  "alerts": {
    "en": "Alerts",
    "nl": "Meldingen"
  },
  "add alert": {
    "en": "Add alert",
    "nl": "Melding toevoegen"
  },
  "resolve alert": {
    "en": "Resolve alert",
    "nl": "Markeer opgelost"
  },
  "resolve alerts": {
    "en": "Resolve alerts",
    "nl": "Markeer opgelost"
  },
  "disconnected": {
    "en": "Disconnected",
    "nl": "Niet verbonden"
  },
  "missingdata": {
    "en": "Missing data",
    "nl": "Ontbrekende gegevens"
  },
  "missing data": {
    "en": "Missing data",
    "nl": "Ontbrekende gegevens"
  },
  "contractedpowerexceeded": {
    "en": "Contracted power exceeded",
    "nl": "GTV overschreden"
  },
  "contracted power exceeded": {
    "en": "Contracted power exceeded",
    "nl": "GTV overschreden"
  },
  "contractedfeedinpowerexceeded": {
    "en": "Contracted feed-in power exceeded",
    "nl": "GTV-T overschreden"
  },
  "contracted feed-in power exceeded": {
    "en": "Contracted feed-in power exceeded",
    "nl": "GTV-T overschreden"
  },
  "incidentfooter": {
    "en": "... and {{count}} more alerts. Try adjusting your filters or narrowing the time range to see more details.",
    "nl": "... en nog {{count}} meer meldingen. Stel een kortere periode in of pas je filters aan om meer details te bekijken."
  },
  "peak": {
    "en": "Peak consumption",
    "nl": "Piek verbruik"
  },
  "add note": {
    "en": "Add note",
    "nl": "Notitie toevoegen"
  },
  "edit note": {
    "en": "Edit note",
    "nl": "Notitie bewerken"
  },
  "assign user": {
    "en": "Assign user",
    "nl": "Medewerker aanwijzen"
  },
  "manage user": {
    "en": "Manage assigned user",
    "nl": "Toegewezen medewerker aanpassen"
  },
  "incidents": {
    "en": "Alerts",
    "nl": "Meldingen"
  },
  "remove user": {
    "en": "Remove assigned user",
    "nl": "Toegewezen medewerker verwijderen"
  },
  "assigned to": {
    "en": "Assigned to",
    "nl": "Toegewezen aan"
  },
  "no user assigned": {
    "en": "No user assigned",
    "nl": "Geen medewerker toegewezen"
  },
  "are you sure you want to remove this user from this alert?": {
    "en": "Are you sure you want to remove this user from this alert?",
    "nl": "Weet je zeker dat je deze medewerker van deze melding wilt verwijderen?"
  },
  "remove": {
    "en": "Remove",
    "nl": "Wissen"
  },
  "notes": {
    "en": "Notes",
    "nl": "Notities"
  },
  "delete note": {
    "en": "Delete note",
    "nl": "Notitie verwijderen"
  },
  "are you sure you want to delete this note?": {
    "en": "Are you sure you want to delete this note?",
    "nl": "Weet je zeker dat je deze notitie wilt verwijderen?"
  },
  "are you sure you want to resolve this alert?": {
    "en": "Are you sure you want to resolve this alert?",
    "nl": "Weet je zeker dat je deze melding als opgelost wilt markeren?"
  },
  "mute alert": {
    "en": "Mute alert",
    "nl": "Melding dempen"
  },
  "reopen alert": {
    "en": "Reopen alert",
    "nl": "Melding heropenen"
  },
  "are you sure you want to reopen this alert?": {
    "en": "Are you sure you want to reopen this alert?",
    "nl": "Weet je zeker dat je deze melding wilt heropenen?"
  },
  "mute alerts": {
    "en": "Mute alerts",
    "nl": "Meldingen dempen"
  },
  "are you sure you want to mute this alert?": {
    "en": "Are you sure you want to mute this alert?",
    "nl": "Weet je zeker dat je deze melding wilt dempen?"
  },
  "alert was added": {
    "en": "Alert was added",
    "nl": "Melding toegevoegd"
  },
  "alert not found": {
    "en": "Alert not found",
    "nl": "Melding niet gevonden"
  },
  "mute deadline": {
    "en": "Mute deadline",
    "nl": "Dempen tot en met"
  },
  "unmute alert": {
    "en": "Unmute alert",
    "nl": "Dempen opheffen"
  },
  "unmute alerts": {
    "en": "Unmute alerts",
    "nl": "Dempen opheffen"
  },
  "alert status": {
    "en": "Alert status",
    "nl": "Melding status"
  },
  "alert type": {
    "en": "Alert type",
    "nl": "Meldingstype"
  },
  "open": {
    "en": "Open",
    "nl": "Open"
  },
  "resolved": {
    "en": "Resolved",
    "nl": "Opgelost"
  },
  "muted": {
    "en": "Muted",
    "nl": "Gedempt"
  },
  "message": {
    "en": "Message",
    "nl": "Bericht"
  },
  "connection type": {
    "en": "Connection type",
    "nl": "Aansluitingstype"
  },
  "bulk edit": {
    "en": "Bulk edit",
    "nl": "Bulk aanpassen"
  },
  "alerts selected": {
    "en": "Alerts selected",
    "nl": "Meldingen geselecteerd"
  },
  "you are about to mute": {
    "en": "You are about to mute",
    "nl": "Je staat op het punt om"
  },
  "bulk mute alerts": {
    "en": "alerts",
    "nl": "meldingen te dempen"
  },
  "you are about to resolve": {
    "en": "You are about to resolve",
    "nl": "Je staat op het punt om"
  },
  "bulk resolve alerts": {
    "en": "alerts",
    "nl": "meldingen als opgelost te markeren"
  },
  "you are about to reopen": {
    "en": "You are about to reopen",
    "nl": "Je staat op het punt om"
  },
  "bulk reopen alerts": {
    "en": "alerts",
    "nl": "meldingen te heropenen"
  },
  "reopen alerts": {
    "en": "Reopen alerts",
    "nl": "Meldingen heropenen"
  },
  "you are about to unmute": {
    "en": "You are about to unmute",
    "nl": "Je staat op het punt om"
  },
  "bulk unmute alerts": {
    "en": "alerts",
    "nl": "meldingen weer actief te maken"
  },
  "are you sure you want to execute this action?": {
    "en": "Are you sure you want to execute this action?",
    "nl": "Weet je zeker dat je deze actie wilt uitvoeren?"
  },
  "no connection found, connection might be removed": {
    "en": "No connection found, connection might be removed",
    "nl": "Geen aansluiting gevonden, waarschijnlijk is de aansluiting verwijderd"
  },
  "you are about to bulk update the following connections": {
    "en": "You are about to bulk update the following connections",
    "nl": "Je staat op het punt om de volgende aansluitingen in bulk te updaten"
  },
  "bulk update connections": {
    "en": "Bulk update connections",
    "nl": "Aansluitingen in bulk updaten"
  },
  "update connections": {
    "en": "Update connections",
    "nl": "Aansluitingen updaten"
  },
  "locations list": {
    "en": "Locations list",
    "nl": "Locatielijst"
  },
  "bag and ep-online audit": {
    "en": "BAG and EP-Online audit",
    "nl": "BAG- en EP-Online-audit"
  },
  "update bag and ep-online data": {
    "en": "Update BAG and EP-Online data",
    "nl": "BAG- en EP-Online-gegevens bijwerken"
  },
  "bag and ep-online update has started": {
    "en": "BAG and EP-Online update has started",
    "nl": "Het bijwerken van BAG en EP-Online is gestart"
  },
  "bulk update locations": {
    "en": "Bulk update locations",
    "nl": "Locaties in bulk updaten"
  },
  "update locations": {
    "en": "Update locations",
    "nl": "Locaties updaten"
  },
  "you are about to bulk update the following locations": {
    "en": "You are about to bulk update the following locations",
    "nl": "Je staat op het punt om de volgende locaties in bulk te updaten"
  },
  "no changes have been found between uploaded file and current data": {
    "en": "No changes have been found between uploaded file and current data",
    "nl": "Er zijn geen verschillen gevonden tussen het geüploade bestand en de data op de server"
  },
  "toggle all days": {
    "en": "Show all days",
    "nl": "Toon alle dagen"
  },
  "days of week": {
    "en": "Days of week",
    "nl": "Dagen van de week"
  },
  "average energy profile": {
    "en": "Average energy profile",
    "nl": "Gemiddeld energieprofiel"
  },
  "official holidays only": {
    "en": "Show official holidays",
    "nl": "Toon officiële feestdagen"
  },
  "monday": {
    "en": "Monday",
    "nl": "Maandag"
  },
  "tuesday": {
    "en": "Tuesday",
    "nl": "Dinsdag"
  },
  "wednesday": {
    "en": "Wednesday",
    "nl": "Woensdag"
  },
  "thursday": {
    "en": "Thursday",
    "nl": "Donderdag"
  },
  "friday": {
    "en": "Friday",
    "nl": "Vrijdag"
  },
  "saturday": {
    "en": "Saturday",
    "nl": "Zaterdag"
  },
  "sunday": {
    "en": "Sunday",
    "nl": "Zondag"
  },
  "alert channels": {
    "en": "Alert channels",
    "nl": "Alert kanalen"
  },
  "create slack alert channel": {
    "en": "Create slack alert channel",
    "nl": "Slack alert koppeling toevoegen"
  },
  "delete channel": {
    "en": "Delete channel",
    "nl": "Kanaal verwijderen"
  },
  "create alert channel": {
    "en": "Create alert channel",
    "nl": "Alert koppeling toevoegen"
  },
  "channel type": {
    "en": "Channel type",
    "nl": "Kanaaltype"
  },
  "errors": {
    "en": "Errors",
    "nl": "Fouten"
  },
  "add new channel": {
    "en": "Add new channel",
    "nl": "Alert koppeling toevoegen"
  },
  "resolve": {
    "en": "Resolve",
    "nl": "Markeer opgelost"
  },
  "resolve errors": {
    "en": "Resolve errors",
    "nl": "Markeer opgelost"
  },
  "status": {
    "en": "Status",
    "nl": "Status"
  },
  "mute errors": {
    "en": "Mute errors",
    "nl": "Fouten dempen"
  },
  "actions": {
    "en": "Actions",
    "nl": "Acties"
  },
  "settings": {
    "en": "Settings",
    "nl": "Instellingen"
  },
  "monitoring": {
    "en": "Monitoring",
    "nl": "Toezicht"
  },
  "contracts": {
    "en": "Contracts",
    "nl": "Contracten"
  },
  "contract": {
    "en": "Contract",
    "nl": "Contract"
  },
  "rate": {
    "en": "Rate",
    "nl": "Tarief"
  },
  "normal rate": {
    "en": "Normal rate",
    "nl": "Normaaltarief"
  },
  "off peak rate": {
    "en": "Off Peak Rate",
    "nl": "Daltarief"
  },
  "normal feed-in rate": {
    "en": "Normal Feed-in Rate",
    "nl": "Normaaltarief teruglevering"
  },
  "feed-in off peak rate": {
    "en": "Off-peak rate feed-in",
    "nl": "Daltarief teruglevering"
  },
  "add period": {
    "en": "Add period",
    "nl": "Periode toevoegen"
  },
  "edit contract period": {
    "en": "Edit contract period",
    "nl": "Contractperiode bewerken"
  },
  "remove period": {
    "en": "Remove period",
    "nl": "Periode verwijderen"
  },
  "are you sure you want to remove this contract period?": {
    "en": "Are you sure you want to delete this contract period?",
    "nl": "Weet u zeker dat u deze contractperiode wilt verwijderen?"
  },
  "add contract period": {
    "en": "Add contract period",
    "nl": "Contractperiode toevoegen"
  },
  "add contract": {
    "en": "Add contract",
    "nl": "Contract toevoegen"
  },
  "remove contract": {
    "en": "Remove contract",
    "nl": "Contract verwijderen"
  },
  "default contract": {
    "en": "Default contract",
    "nl": "Standaardcontract"
  },
  "a default contract will use average consumption costs when no specific contracts are in place.": {
    "en": "A default contract will use average consumption costs when no specific contracts are in place.",
    "nl": "Bij een standaardcontract worden gemiddelde verbruikskosten gehanteerd, indien er geen specifieke contracten van toepassing zijn."
  },
  "are you sure you want to remove this contract?": {
    "en": "Are you sure you want to delete this contract?",
    "nl": "Weet u zeker dat u dit contract wilt verwijderen?"
  },
  "are you sure you want to remove this contract from this organisation?": {
    "en": "Are you sure you want to remove this contract from this organisation?",
    "nl": "Weet u zeker dat u dit contract van deze organisatie wilt verwijderen?"
  },
  "are you sure you want to remove this contract from this connection?": {
    "en": "Are you sure you want to remove this contract from this connection?",
    "nl": "Weet u zeker dat u dit contract van deze aansluiting wilt verwijderen?"
  },
  "start date": {
    "en": "Start date",
    "nl": "Startdatum"
  },
  "end date": {
    "en": "End date",
    "nl": "Einddatum"
  },
  "contract periods": {
    "en": "Contract periods",
    "nl": "Contractperiodes"
  },
  "links": {
    "en": "Links",
    "nl": "Koppelingen"
  },
  "link to organisation": {
    "en": "Link to organisation",
    "nl": "Koppel aan organisatie"
  },
  "link to connection": {
    "en": "Link to connection",
    "nl": "Koppel aan aansluiting"
  },
  "link contract": {
    "en": "Link contract",
    "nl": "Koppel contract"
  },
  "delete contract period": {
    "en": "Delete contract period",
    "nl": "Contractperiode verwijderen"
  },
  "you are about to delete": {
    "en": "You are about to delete",
    "nl": "Je staat op het punt om"
  },
  "this channel.": {
    "en": "this channel.",
    "nl": "dit kanaal te verwijderen."
  },
  "this contract period.": {
    "en": "this contract period",
    "nl": "deze contractperiode te verwijderen"
  },
  "this tax.": {
    "en": "this tax.",
    "nl": "deze belasting te verwijderen"
  },
  "this period.": {
    "en": "this period",
    "nl": "deze periode te verwijderen"
  },
  "this contract.": {
    "en": "this contract.",
    "nl": "dit contract te verwijderen."
  },
  "link connection to contract": {
    "en": "Link Connection to Contract",
    "nl": "Koppel aan aansluiting"
  },
  "electricity standing charge": {
    "en": "Standing charge (electricity)",
    "nl": "Vaste leveringskosten elektriciteit"
  },
  "electricity standing charge (estimated)": {
    "en": "Standing charge electricity (estimated)",
    "nl": "Vaste leveringskosten elektriciteit (geschat)"
  },
  "gas standing charge": {
    "en": "Standing charge (gas)",
    "nl": "Vaste leveringskosten gas"
  },
  "gas standing charge (estimated)": {
    "en": "Standing charge gas (estimated)",
    "nl": "Vaste leveringskosten gas (geschat)"
  },
  "standing charge": {
    "en": "Standing charge",
    "nl": "Vaste leveringskosten"
  },
  "link organisation": {
    "en": "Link organisation",
    "nl": "Koppel aan organisatie"
  },
  "link connection": {
    "en": "Link connection",
    "nl": "Koppel aan aansluiting"
  },
  "please enter a connection type": {
    "en": "Please enter a connection type",
    "nl": "Voer een aansluiting in"
  },
  "cooling": {
    "en": "Cooling",
    "nl": "Koude"
  },
  "cooling consumption": {
    "en": "Cooling",
    "nl": "Koudeverbruik"
  },
  "product": {
    "en": "Product",
    "nl": "Product"
  },
  "contract owner": {
    "en": "Contract owner",
    "nl": "Contractbeheerder"
  },
  "selection": {
    "en": "Selection",
    "nl": "Selectie"
  },
  "delete contract": {
    "en": "Delete contract",
    "nl": "Contract verwijderen"
  },
  "add new connection": {
    "en": "Add new connection",
    "nl": "Connectie toevoegen"
  },
  "locations were uploaded successfully": {
    "en": "Locations were uploaded successfully",
    "nl": "De locaties zijn succesvol geüpload"
  },
  "connections were uploaded successfully": {
    "en": "Connections were uploaded successfully",
    "nl": "De aansluitingen zijn succesvol geüpload"
  },
  "sustainability source": {
    "en": "Sustainability Source",
    "nl": "Duurzaamheidsbron"
  },
  "eu wind": {
    "en": "EU wind",
    "nl": "EU wind"
  },
  "eu zon": {
    "en": "EU solar",
    "nl": "EU zon"
  },
  "nl wind": {
    "en": "NL wind",
    "nl": "NL wind"
  },
  "nl zon": {
    "en": "NL solar",
    "nl": "NL zon"
  },
  "nl wind (smk)": {
    "en": "NL wind (SMK)",
    "nl": "NL wind (SMK)"
  },
  "grijs": {
    "en": "Grey energy",
    "nl": "Grijs"
  },
  "mix": {
    "en": "Mix",
    "nl": "Mix"
  },
  "biomassa": {
    "en": "Biomass",
    "nl": "Biomassa"
  },
  "co2 compensatie": {
    "en": "CO2 compensation",
    "nl": "CO2 compensatie"
  },
  "delete authorisation": {
    "en": "Delete authorisation",
    "nl": "Machtiging verwijderen"
  },
  "taxes": {
    "en": "Taxes",
    "nl": "Belastingen"
  },
  "add tax": {
    "en": "Add tax",
    "nl": "Belasting toevoegen"
  },
  "edit tax": {
    "en": "Edit tax",
    "nl": "Belasting aanpassen"
  },
  "this period": {
    "en": "this period",
    "nl": "deze periode"
  },
  "remove tax": {
    "en": "Remove tax",
    "nl": "Belasting verwijderen"
  },
  "tax brackets": {
    "en": "Tax brackets",
    "nl": "Belastingschijven"
  },
  "min": {
    "en": "Min",
    "nl": "Min"
  },
  "max": {
    "en": "Max",
    "nl": "Max"
  },
  "residential rate": {
    "en": "Residential Rate",
    "nl": "Tarief verblijfsfunctie"
  },
  "residential function": {
    "en": "Residential function",
    "nl": "Verblijfsfunctie"
  },
  "edit period": {
    "en": "Edit period",
    "nl": "Periode aanpassen"
  },
  "rate includes ode": {
    "en": "Rate includes ODE",
    "nl": "Tarief inclusief ODE"
  },
  "are you sure you want to remove this tax period?": {
    "en": "Are you sure you want to remove this tax period?",
    "nl": "Weet u zeker dat u deze belastingperiode wilt verwijderen?"
  },
  "select one or more connections": {
    "en": "Select one or more connections",
    "nl": "Selecteer één of meerdere aansluitingen"
  },
  "download as image": {
    "en": "Download as image",
    "nl": "Download als afbeelding"
  },
  "download table": {
    "en": "Download table",
    "nl": "Download tabelweergave"
  },
  "download raw data": {
    "en": "Download raw data",
    "nl": "Download ruwe data"
  },
  "download measurement data": {
    "en": "Download measurement data",
    "nl": "Meetdata downloaden"
  },
  "download quarter-hour data": {
    "en": "Download quarter-hour data",
    "nl": "Download kwartierdata"
  },
  "quarter-hour data is only available for electricity connections": {
    "en": "Quarter-hour data is only available for electricity connections",
    "nl": "Kwartierdata is alleen beschikbaar voor elektriciteitsaansluitingen"
  },
  "download hourly data": {
    "en": "Download hourly data",
    "nl": "Download uurdata"
  },
  "download daily data": {
    "en": "Download daily data",
    "nl": "Download dagdata"
  },
  "download monthly data": {
    "en": "Download monthly data",
    "nl": "Download maanddata"
  },
  "download yearly data": {
    "en": "Download yearly data",
    "nl": "Download jaardata"
  },
  "data download is only possible below a selection of": {
    "en": "Data download is only possible below a selection of",
    "nl": "Data download is alleen beschikbaar bij een selectie van minder dan"
  },
  "generate new api key": {
    "en": "Generate new API Key",
    "nl": "API key aanmaken"
  },
  "create api key": {
    "en": "Add new API key",
    "nl": "API key aanmaken"
  },
  "no api keys found": {
    "en": "No API keys found",
    "nl": "Geen API-keys gevonden"
  },
  "api keys": {
    "en": "API keys",
    "nl": "API keys"
  },
  "you don’t have any api keys yet": {
    "en": "You don’t have any API keys yet",
    "nl": "U hebt nog geen API-keys"
  },
  "new api key": {
    "en": "New API Key",
    "nl": "Nieuwe API-key"
  },
  "enter a suitable name for this api key, e.g. github": {
    "en": "Enter a suitable name for this API key, e.g. Github",
    "nl": "Voer een geschikte naam in voor deze API-key, bijvoorbeeld Github"
  },
  "are you sure you want to delete this api key? deleting it will prevent future requests from being processed, which may disrupt existing integrations with our api.": {
    "en": "Are you sure you want to delete this API key? Deleting it will prevent future requests from being processed, which may disrupt existing integrations with our API.",
    "nl": "Weet u zeker dat u deze API-key wilt verwijderen? Verzoeken met deze token werken dan niet meer, wat bestaande integraties met onze API kan verstoren."
  },
  "cycle api key": {
    "en": "Cycle API key",
    "nl": "API-key vernieuwen"
  },
  "you have successfully created your api key": {
    "en": "You have successfully created your API key",
    "nl": "Uw API-key is succesvol aangemaakt."
  },
  "copy": {
    "en": "Copy",
    "nl": "Kopiëren"
  },
  "delete api key": {
    "en": "Delete API key",
    "nl": "API-key verwijderen"
  },
  "created:": {
    "en": "Created: ",
    "nl": "Aangemaakt op: "
  },
  "edit api key": {
    "en": "Edit API key",
    "nl": "API-key bewerken"
  },
  "this will cause the old key to not work anymore. are you sure you want to cycle this key?": {
    "en": "This will cause the old key to not work anymore. Are you sure you want to cycle this key?",
    "nl": "Dit zal ervoor zorgen dat de oude API key niet meer werkt. Weet u zeker dat u deze token wilt vernieuwen?"
  },
  "this is a list of keys associated with your account. remove any keys that you do not recognize.": {
    "en": "This is a list of keys associated with your account. Remove any keys that you do not recognize.",
    "nl": "Dit is een lijst van API keys die aan jouw account zijn gekoppeld. Verwijder de keys die je niet herkent."
  },
  "important:": {
    "en": "Important: ",
    "nl": "Belangrijk: "
  },
  "copy and save it": {
    "en": " copy and save it ",
    "nl": " kopieert en opslaat"
  },
  "for your security, the api key/token will only be shown once. be sure to": {
    "en": "for your security, the api key/token will only be shown once. Be sure to ",
    "nl": "Voor uw veiligheid wordt de API-key/token slechts één keer weergegeven. Zorg ervoor dat u deze onmiddellijk na het aanmaken "
  },
  "immediately after creation, as it will not be accessible again. if you lose it, you'll need to generate a new one.": {
    "en": "immediately after creation, as it will not be accessible again. If you lose it, you'll need to generate a new one.",
    "nl": ", aangezien deze daarna niet meer toegankelijk zal zijn. Als u deze verliest, moet u een nieuwe genereren."
  },
  "your newly generated api key": {
    "en": "Your newly generated API Key",
    "nl": "Uw nieuwe API-key"
  },
  "this api key will allow you to authenticate your requests. please copy and save it immediately, as it will only be shown once.": {
    "en": "This API key will allow you to authenticate your requests. Please copy and save it immediately, as it will only be shown once.",
    "nl": "Deze API-key stelt je in staat om je verzoeken te verifiëren. Kopieer en bewaar deze meteen, want deze wordt maar één keer getoond."
  },
  "to get started, you can": {
    "en": "To get started, you can ",
    "nl": "Begin door "
  },
  "add a new api key.": {
    "en": "add a new API key.",
    "nl": "een nieuwe API-key toe te voegen."
  },
  "description": {
    "en": "Description",
    "nl": "Omschrijving"
  },
  "use the token below in the authorization header to access the flowmaps api:": {
    "en": "Use the token below in the Authorization header to access the Flowmaps API:",
    "nl": "Gebruik de onderstaande token in de Authorization-header om toegang te krijgen tot de Flowmaps API:"
  },
  "download and close": {
    "en": "Download and close",
    "nl": "Downloaden en sluiten"
  },
  "copy header": {
    "en": "Copy header",
    "nl": "Header kopiëren"
  },
  "the token for this api key has been updated successfully.": {
    "en": "The token for this API key has been updated successfully.",
    "nl": "Het token voor deze API-key is succesvol bijgewerkt."
  },
  "the flowmaps api provides secure access to organization and meter data for third-party applications. for more information on how to use the api, refer to the": {
    "en": "The Flowmaps API provides secure access to organization and meter data for third-party applications. For more information on how to use the API, refer to the ",
    "nl": "De Flowmaps API biedt veilige toegang tot organisatie- en meterdata voor externe applicaties. Voor meer informatie over het gebruik van de API, bekijk de"
  },
  "documentation": {
    "en": "documentation",
    "nl": "handleiding"
  },
  "this connection has active meters. deleting it will also remove all associated meters and meter data.": {
    "en": "This connection has active meters. Deleting it will also remove all associated meters and meter data.",
    "nl": "Deze aansluiting heeft actieve meters. Als u deze verwijdert, worden ook alle bijbehorende meters en meetdata verwijderd."
  },
  "this location has active meters. deleting it will also remove all associated meters and meter data.": {
    "en": "This location has active meters. Deleting it will also remove all associated meters and meter data.",
    "nl": "Deze locatie heeft actieve meters. Als u deze verwijdert, worden ook alle bijbehorende meters en meetdata verwijderd."
  },
  "this connection has active meters. moving it will also move all associated meters and meter data.": {
    "en": "This connection has active meters. Moving it will also move all associated meters and meter data.",
    "nl": "Deze aansluiting heeft actieve meters. Het verplaatsen hiervan zal ook alle bijbehorende meters en meetdata verplaatsen."
  },
  "are you sure you want to continue?": {
    "en": "Are you sure you want to continue?",
    "nl": "Weet je zeker dat je deze actie wilt uitvoeren?"
  },
  "this location has active meters. moving it will also move all associated meters and meter data.": {
    "en": "This location has active meters. Moving it will also move all associated meters and meter data.",
    "nl": "Deze locatie heeft actieve meters. Het verplaatsen hiervan zal ook alle bijbehorende meters en meetdata verplaatsen."
  },
  "move location": {
    "en": "Move location",
    "nl": "Locatie verplaatsen"
  },
  "move connection": {
    "en": "Move connection",
    "nl": "Aansluiting verplaatsen"
  },
  "new organisation": {
    "en": "New organisation",
    "nl": "Nieuwe organisatie"
  },
  "new location": {
    "en": "New location",
    "nl": "Nieuwe locatie"
  },
  "move connection to another location": {
    "en": "Move connection to another location",
    "nl": "Aansluiting naar een andere locatie verplaatsen"
  },
  "move location to another organisation": {
    "en": "Move location to another organisation",
    "nl": "Locatie naar een andere organisatie verplaatsen"
  },
  "charge points": {
    "en": "Charge Points",
    "nl": "Laadpunten"
  },
  "charge point": {
    "en": "Charge Point",
    "nl": "Laadpaal"
  },
  "charge point consumption": {
    "en": "EV consumption",
    "nl": "Laadverbruik"
  },
  "charge point intermediate consumption": {
    "en": "EV intermediate consumption",
    "nl": "Tussenmeterverbruik laadpunt"
  },
  "charge point power": {
    "en": "EV power",
    "nl": "Piekvermogen (laadpunt)"
  },
  "chargepoint": {
    "en": "Charge Point",
    "nl": "Laadpunt"
  },
  "no users found": {
    "en": "No users found",
    "nl": "Geen gebruikers gevonden"
  },
  "try adjusting your filters or search term": {
    "en": "Try adjusting your filters or search term",
    "nl": "Probeer je filters of zoekterm aan te passen"
  },
  "no locations found": {
    "en": "No locations found",
    "nl": "Geen locaties gevonden"
  },
  "no organisations found": {
    "en": "No organisations found",
    "nl": "Geen organisaties gevonden"
  },
  "no connections found": {
    "en": "No connections found",
    "nl": "Geen aansluitingen gevonden"
  },
  "no contracts found": {
    "en": "No contracts found",
    "nl": "Geen contracten gevonden"
  },
  "no taxes found": {
    "en": "No taxes found",
    "nl": "Geen energiebelastingen gevonden"
  },
  "end date cannot be set in the past.": {
    "en": "End date cannot be set in the past.",
    "nl": "Het is niet mogelijk om een einddatum in het verleden in te stellen."
  },
  "clear filters": {
    "en": "Clear filters",
    "nl": "Filters wissen"
  },
  "alerts list": {
    "en": "Alerts list",
    "nl": "Meldingenlijst"
  },
  "energy flows": {
    "en": "Energy flows",
    "nl": "Energiestromen"
  },
  "inactive": {
    "en": "Inactive",
    "nl": "Inactief"
  },
  "quarterly report": {
    "en": "Quarterly report",
    "nl": "Kwartaalrapport"
  },
  "quarter": {
    "en": "Quarter",
    "nl": "Kwartaal"
  },
  "gas and heat: energy profile": {
    "en": "Gas and heat: energy profile",
    "nl": "Gas en warmte: energieprofiel"
  },
  "the energy profile shows the relationship between outside temperature and heat consumption. this analysis helps assess the performance of heating systems and provides insight into baseloads, control behaviour, and possible opportunities to optimize energy use.": {
    "en": "The energy profile shows the relationship between outside temperature and heat consumption. This analysis helps assess the performance of heating systems and provides insight into baseloads, control behaviour, and possible opportunities to optimize energy use.",
    "nl": "Het energieprofiel toont de relatie tussen buitentemperatuur en warmteverbruik. Deze analyse helpt bij het beoordelen van de prestatie van verwarmingsinstallaties en geeft inzicht in basislasten, regelgedrag en mogelijke optimalisatie van het energiegebruik."
  },
  "gas: official holiday day profiles": {
    "en": "Gas: official holiday day profiles",
    "nl": "Gas: officiële feestdag dagprofielen"
  },
  "heat: official holiday day profiles": {
    "en": "Heat: official holiday day profiles",
    "nl": "Warmte: officiële feestdag dagprofielen"
  },
  "water: official holiday day profiles": {
    "en": "Water: official holiday day profiles",
    "nl": "Water: officiële feestdag dagprofielen"
  },
  "electricity: official holiday day profiles": {
    "en": "Electricity: official holiday day profiles",
    "nl": "Elektriciteit: dagprofielen feestdagen"
  },
  "charge points: official holiday day profiles": {
    "en": "Charge points: official holiday day profiles",
    "nl": "Laadpalen: dagprofielen feestdagen"
  },
  "summary": {
    "en": "Summary",
    "nl": "Samenvatting"
  },
  "energy performance summary": {
    "en": "Energy performance summary",
    "nl": "Energieprestatieoverzicht"
  },
  "this overview summarizes the total energy costs and associated co2 emissions for the selected reporting period. the weii compass compares the location's performance with the paris-proof target.": {
    "en": "This overview summarizes the total energy costs and associated CO2 emissions for the selected reporting period. The WEII compass compares the location's performance with the Paris-proof target.",
    "nl": "Dit overzicht vat de totale energiekosten en bijbehorende CO2-uitstoot van de geselecteerde rapportageperiode samen. Het WEII-kompas vergelijkt de prestaties van de locatie met de doelstelling van het Parijs Akkoord."
  },
  "weii compass": {
    "en": "WEII compass",
    "nl": "WEII-kompas"
  },
  "postal code / city": {
    "en": "Postal code / city",
    "nl": "Postcode / plaats"
  },
  "floor area": {
    "en": "Floor area",
    "nl": "Gebruiksoppervlakte"
  },
  "ean code electricity": {
    "en": "EAN code electricity",
    "nl": "EAN-code elektriciteit"
  },
  "ean code gas": {
    "en": "EAN code gas",
    "nl": "EAN-code gas"
  },
  "ean code heat": {
    "en": "EAN code heat",
    "nl": "EAN-code warmte"
  },
  "reporting period": {
    "en": "Reporting period",
    "nl": "Rapportperiode"
  },
  "electricity: consumption per month": {
    "en": "Electricity: consumption per month",
    "nl": "Elektriciteit: verbruik per maand"
  },
  "this analysis provides insight into the location's monthly electricity consumption and compares performance with the previous period. by highlighting trends and deviations, it reveals seasonal effects, operational use, and possible optimization opportunities within the building-related energy use.": {
    "en": "This analysis provides insight into the location's monthly electricity consumption and compares performance with the previous period. By highlighting trends and deviations, it reveals seasonal effects, operational use, and possible optimization opportunities within the building-related energy use.",
    "nl": "Deze analyse geeft inzicht in het maandelijkse elektriciteitsverbruik van de locatie en vergelijkt de prestaties met de voorgaande periode. Door trends en afwijkingen zichtbaar te maken ontstaat inzicht in seizoensinvloeden, operationeel gebruik en mogelijke optimalisatiekansen binnen het gebouwgebonden energieverbruik."
  },
  "gas and heat: consumption per month": {
    "en": "Gas and heat: consumption per month",
    "nl": "Gas en warmte: verbruik per maand"
  },
  "this analysis shows the location's monthly heat and gas consumption compared with earlier periods. the data provides insight into how heat demand develops through the year and supports the identification of seasonal patterns and abnormal energy use.": {
    "en": "This analysis shows the location's monthly heat and gas consumption compared with earlier periods. The data provides insight into how heat demand develops through the year and supports the identification of seasonal patterns and abnormal energy use.",
    "nl": "Deze analyse toont het maandelijkse warmte- en gasverbruik van de locatie in vergelijking met eerdere perioden. De gegevens geven inzicht in de ontwikkeling van de warmtevraag gedurende het jaar en ondersteunen het identificeren van seizoenspatronen en afwijkend energiegebruik."
  },
  "gas and heat: consumption per degree day": {
    "en": "Gas and heat: consumption per degree day",
    "nl": "Gas en warmte: verbruik per graaddag"
  },
  "this analysis corrects heat consumption for weather influences (heating degree days, hdd). it provides better insight into the actual efficiency of heating systems and building use, independent of temperature fluctuations.": {
    "en": "This analysis corrects heat consumption for weather influences (heating degree days, HDD). It provides better insight into the actual efficiency of heating systems and building use, independent of temperature fluctuations.",
    "nl": "In deze analyse wordt het warmteverbruik gecorrigeerd op basis van weersinvloeden (graaddagen). Hierdoor ontstaat beter inzicht in de daadwerkelijke efficiëntie van de verwarmingsinstallaties en het gebouwgebruik, onafhankelijk van temperatuurschommelingen."
  },
  "water: consumption per month": {
    "en": "Water: consumption per month",
    "nl": "Water: verbruik per maand"
  },
  "charge points: consumption per month": {
    "en": "Charge points: consumption per month",
    "nl": "Laadpalen: verbruik per maand"
  },
  "day profiles": {
    "en": "Day profiles",
    "nl": "Dagprofielen"
  },
  "electricity: day profiles": {
    "en": "Electricity: day profiles",
    "nl": "Elektriciteit: dagprofielen"
  },
  "the day profiles provide insight into electricity consumption throughout the day, broken down by weekday. they make usage patterns, peak moments, and baseloads visible, supporting optimization of installations and operational processes.": {
    "en": "The day profiles provide insight into electricity consumption throughout the day, broken down by weekday. They make usage patterns, peak moments, and baseloads visible, supporting optimization of installations and operational processes.",
    "nl": "De dagprofielen geven inzicht in het elektriciteitsverbruik gedurende de dag, uitgesplitst per weekdag. Hiermee worden gebruikspatronen, piekmomenten en basislasten zichtbaar, wat ondersteuning biedt bij het optimaliseren van installaties en operationele processen."
  },
  "gas: day profiles": {
    "en": "Gas: day profiles",
    "nl": "Gas: dagprofielen"
  },
  "this analysis shows the daily pattern of gas consumption by weekday. the profiles provide insight into start-up moments, daily gas demand, and the control behaviour of the heating system.": {
    "en": "This analysis shows the daily pattern of gas consumption by weekday. The profiles provide insight into start-up moments, daily gas demand, and the control behaviour of the heating system.",
    "nl": "Deze analyse toont het verloop van het gasverbruik gedurende de dag per weekdag. De profielen geven inzicht in opstartmomenten, dagelijkse gasvraag en het regelgedrag van de verwarmingsinstallatie."
  },
  "this analysis shows the daily pattern of heat consumption by weekday. the profiles provide insight into start-up moments, daily heat demand, and the control behaviour of the heating system.": {
    "en": "This analysis shows the daily pattern of heat consumption by weekday. The profiles provide insight into start-up moments, daily heat demand, and the control behaviour of the heating system.",
    "nl": "Deze analyse toont het verloop van het warmteverbruik gedurende de dag per weekdag. De profielen geven inzicht in opstartmomenten, dagelijkse warmtevraag en het regelgedrag van de verwarmingsinstallatie."
  },
  "heat: day profiles": {
    "en": "Heat: day profiles",
    "nl": "Warmte: dagprofielen"
  },
  "water: day profiles": {
    "en": "Water: day profiles",
    "nl": "Water: dagprofielen"
  },
  "charge points: day profiles": {
    "en": "Charge points: day profiles",
    "nl": "Laadpalen: dagprofielen"
  },
  "official holidays": {
    "en": "Official holidays",
    "nl": "Feestdagen"
  },
  "no official holidays are available for this report.": {
    "en": "No official holidays are available for this report.",
    "nl": "Er zijn geen feestdagen beschikbaar voor dit rapport."
  },
  "holiday consumption": {
    "en": "Holiday consumption",
    "nl": "Verbruik feestdagen"
  },
  "this analysis provides insight into energy consumption during official holidays. by comparing consumption on these days with regular operating days, it becomes clear to what extent installations and building functions are scaled back outside regular occupancy.": {
    "en": "This analysis provides insight into energy consumption during official holidays. By comparing consumption on these days with regular operating days, it becomes clear to what extent installations and building functions are scaled back outside regular occupancy.",
    "nl": "Deze analyse geeft inzicht in het energieverbruik tijdens officiële feestdagen. Door het verbruik op deze dagen te vergelijken met reguliere gebruiksdagen ontstaat inzicht in de mate waarin installaties en gebouwfuncties worden teruggeschakeld buiten reguliere bezetting."
  },
  "date": {
    "en": "Date",
    "nl": "Datum"
  },
  "holiday": {
    "en": "Holiday",
    "nl": "Feestdag"
  },
  "new year's day": {
    "en": "New Year's Day",
    "nl": "Nieuwjaarsdag"
  },
  "easter sunday": {
    "en": "Easter Sunday",
    "nl": "Eerste Paasdag"
  },
  "easter monday": {
    "en": "Easter Monday",
    "nl": "Tweede Paasdag"
  },
  "king's day": {
    "en": "King's Day",
    "nl": "Koningsdag"
  },
  "ascension day": {
    "en": "Ascension Day",
    "nl": "Hemelvaartsdag"
  },
  "pentecost sunday": {
    "en": "Pentecost Sunday",
    "nl": "Eerste Pinksterdag"
  },
  "pentecost monday": {
    "en": "Pentecost Monday",
    "nl": "Tweede Pinksterdag"
  },
  "christmas day": {
    "en": "Christmas Day",
    "nl": "Eerste Kerstdag"
  },
  "boxing day": {
    "en": "Boxing Day",
    "nl": "Tweede Kerstdag"
  },
  "peak exceedances": {
    "en": "Peak exceedances",
    "nl": "Piekoverschrijdingen"
  },
  "highest contracted power and feed-in power exceedances per connection in the selected reporting period.": {
    "en": "Highest contracted power and feed-in power exceedances per connection in the selected reporting period.",
    "nl": "Hoogste GTV- en GTV-T-overschrijdingen per aansluiting in de geselecteerde rapportageperiode."
  },
  "top 10 consumption exceedances": {
    "en": "Top 10 consumption exceedances",
    "nl": "Top 10 overschrijdingen levering"
  },
  "top 5 feed-in exceedances": {
    "en": "Top 5 feed-in exceedances",
    "nl": "Top 5 overschrijdingen teruglevering"
  },
  "moment": {
    "en": "Moment",
    "nl": "Moment"
  },
  "measured load": {
    "en": "Measured load",
    "nl": "Piekvermogen"
  },
  "exceeded by": {
    "en": "Exceeded by",
    "nl": "Boven GTV"
  },
  "no contracted power or feed-in power exceedances were found in this reporting period.": {
    "en": "No contracted power or feed-in power exceedances were found in this reporting period.",
    "nl": "Geen GTV- of GTV-T-overschrijdingen gevonden in deze rapportageperiode."
  },
  "quarter reports": {
    "en": "Quarter reports",
    "nl": "Kwartaalrapportages"
  },
  "provisional": {
    "en": "Provisional",
    "nl": "Voorlopig"
  },
  "display settings": {
    "en": "Display settings",
    "nl": "Weergave-instellingen"
  },
  "calculation year": {
    "en": "Calculation year",
    "nl": "Berekeningsjaar"
  },
  "automatic": {
    "en": "Automatic",
    "nl": "Automatisch"
  },
  "comparison year": {
    "en": "Comparison year",
    "nl": "Vergelijkingsjaar"
  },
  "show all building types": {
    "en": "Show all building types",
    "nl": "Toon alle gebouwtypes"
  },
  "pinned": {
    "en": "Pinned",
    "nl": "Vastgezet"
  },
  "each building type has its own weii thresholds for the paris agreement and the other efficiency classes. buildings are positioned according to the thresholds for their own building type. the numerical y-axis is only shown when one building type is selected.": {
    "en": "Each building type has its own WEii thresholds for the Paris Agreement and the other efficiency classes. Buildings are positioned according to the thresholds for their own building type. The numerical Y-axis is only shown when one building type is selected.",
    "nl": "Ieder gebouwtype heeft eigen WEii-grenswaarden voor het Parijs Akkoord en de overige efficiëntieklassen. Gebouwen worden volgens de grenswaarden van hun eigen gebouwtype op het Energiekompas gepositioneerd. De numerieke Y-as wordt alleen getoond wanneer één gebouwtype is geselecteerd."
  },
  "ranking options": {
    "en": "Ranking options",
    "nl": "Rangschikkingsopties"
  },
  "show locations as": {
    "en": "Show locations as",
    "nl": "Toon locaties als"
  },
  "object": {
    "en": "Object",
    "nl": "Object"
  },
  "profile settings": {
    "en": "Profile settings",
    "nl": "Profielinstellingen"
  },
  "advanced calculation options": {
    "en": "Advanced calculation options",
    "nl": "Geavanceerde berekeningsopties"
  },
  "exclude ev charging consumption": {
    "en": "Exclude EV charging consumption",
    "nl": "Laadverbruik uitsluiten"
  },
  "refine the weii score by excluding separately metered ev charging consumption from the building performance. this provides a more representative view of the building's energy efficiency.": {
    "en": "Refine the WEii score by excluding separately metered EV charging consumption from the building performance. This provides a more representative view of the building's energy efficiency.",
    "nl": "Verfijn de WEii-score door het afzonderlijk gemeten laadverbruik buiten de gebouwprestatie te houden. Zo ontstaat een representatiever beeld van de energie-efficiëntie van het gebouw."
  },
  "not available. this calculation requires measured ev charging consumption.": {
    "en": "Not available. This calculation requires measured EV charging consumption.",
    "nl": "Niet beschikbaar. Voor deze berekening is geen laadpaaldata beschikbaar."
  },
  "include onsite generation": {
    "en": "Include onsite generation",
    "nl": "Eigen opwek meenemen"
  },
  "refine the weii score by including locally generated and directly consumed electricity in the calculation. this provides a more representative view of the building's actual energy use. this option is only available when complete and reliable gross production data is available.": {
    "en": "Refine the WEii score by including locally generated and directly consumed electricity in the calculation. This provides a more representative view of the building's actual energy use. This option is only available when complete and reliable gross production data is available.",
    "nl": "Verfijn de WEii-score door lokaal opgewekte en direct verbruikte elektriciteit mee te nemen in de berekening. Zo ontstaat een representatiever beeld van het werkelijke energiegebruik van het gebouw. Deze optie is alleen beschikbaar wanneer volledige en betrouwbare bruto productiedata beschikbaar is."
  },
  "not available. this calculation requires complete and reliable gross production data.": {
    "en": "Not available. This calculation requires complete and reliable gross production data.",
    "nl": "Niet beschikbaar. Voor deze berekening is volledige en betrouwbare bruto productiedata vereist."
  },
  "normalize climate year": {
    "en": "Normalize climate year",
    "nl": "Klimaatjaar normaliseren"
  },
  "refine the weii score by normalizing climate-sensitive energy use to an average climate year. this allows buildings and different years to be compared more fairly. this option is only available when sufficient climate data is available.": {
    "en": "Refine the WEii score by normalizing climate-sensitive energy use to an average climate year. This allows buildings and different years to be compared more fairly. This option is only available when sufficient climate data is available.",
    "nl": "Verfijn de WEii-score door het klimaatgevoelige energiegebruik te normaliseren naar een gemiddeld klimaatjaar. Zo kunnen gebouwen en verschillende jaren eerlijker met elkaar worden vergeleken. Deze optie is alleen beschikbaar wanneer voldoende klimaatgegevens beschikbaar zijn."
  },
  "refine the weii score by normalizing climate-sensitive gas and heat consumption to the weii 3.1 reference climate of 2,200 heating degree days. the calculation uses a 16.5 °c base temperature and assumes that 80% of gas and heat consumption is used for space heating. this allows buildings and different years to be compared more fairly. enable this option only when that assumption is appropriate for the selected buildings. only complete calculation years are normalized; provisional years continue to show actual consumption.": {
    "en": "Refine the WEii score by normalizing climate-sensitive gas and heat consumption to the WEii 3.1 reference climate of 2,200 heating degree days. The calculation uses a 16.5 °C base temperature and assumes that 80% of gas and heat consumption is used for space heating. This allows buildings and different years to be compared more fairly. Enable this option only when that assumption is appropriate for the selected buildings. Only complete calculation years are normalized; provisional years continue to show actual consumption.",
    "nl": "Verfijn de WEii-score door klimaatgevoelig gas- en warmteverbruik te normaliseren naar het referentieklimaat uit WEii 3.1 van 2.200 graaddagen. De berekening gebruikt een stookgrens van 16,5 °C en gaat ervan uit dat 80% van het gas- en warmteverbruik voor ruimteverwarming wordt gebruikt. Zo kunnen gebouwen en verschillende jaren eerlijker met elkaar worden vergeleken. Gebruik deze optie alleen als die aanname passend is voor de geselecteerde panden. Alleen volledige berekeningsjaren worden genormaliseerd; voorlopige jaren blijven het werkelijke verbruik tonen."
  },
  "display": {
    "en": "Display",
    "nl": "Weergave"
  },
  "actual consumption": {
    "en": "Actual consumption",
    "nl": "Werkelijk verbruik"
  },
  "climate normalized": {
    "en": "Climate normalized",
    "nl": "Klimaatgenormaliseerd"
  },
  "climate year corrected": {
    "en": "Climate year corrected",
    "nl": "Klimaatjaar gecorrigeerd"
  },
  "compare with actual consumption": {
    "en": "Compare with actual consumption",
    "nl": "Vergelijk met werkelijk verbruik"
  },
  "refine the gas and heat display by normalizing climate-sensitive consumption to the weii 3.1 reference climate of 2,200 heating degree days. the calculation uses a 16.5 °c base temperature and assumes that 80% of gas and heat consumption is used for space heating. this allows different periods to be compared more fairly. enable this option only when that assumption is appropriate for the selected buildings. the correction factor is calculated over the complete selected period. climate year normalization is available in month and year views.": {
    "en": "Refine the gas and heat display by normalizing climate-sensitive consumption to the WEii 3.1 reference climate of 2,200 heating degree days. The calculation uses a 16.5 °C base temperature and assumes that 80% of gas and heat consumption is used for space heating. This allows different periods to be compared more fairly. Enable this option only when that assumption is appropriate for the selected buildings. The correction factor is calculated over the complete selected period. Climate year normalization is available in month and year views.",
    "nl": "Verfijn de weergave van gas en warmte door klimaatgevoelig verbruik te normaliseren naar het referentieklimaat uit WEii 3.1 van 2.200 graaddagen. De berekening gebruikt een stookgrens van 16,5 °C en gaat ervan uit dat 80% van het gas- en warmteverbruik voor ruimteverwarming wordt gebruikt. Zo kunnen verschillende perioden eerlijker met elkaar worden vergeleken. Gebruik deze optie alleen als die aanname passend is voor de geselecteerde panden. De correctiefactor wordt berekend over de volledige geselecteerde periode. Klimaatjaar normaliseren is beschikbaar in maand- en jaarweergaven."
  },
  "compare actual and climate normalized": {
    "en": "Compare actual and climate normalized",
    "nl": "Werkelijk en klimaatgenormaliseerd vergelijken"
  },
  "normalized to the weii 3.1 reference climate using heating degree days with a 16.5 °c base temperature. the calculation assumes that 80% of gas and heat consumption is used for space heating.": {
    "en": "Normalized to the WEii 3.1 reference climate using heating degree days with a 16.5 °C base temperature. The calculation assumes that 80% of gas and heat consumption is used for space heating.",
    "nl": "Genormaliseerd naar het referentieklimaat uit WEii 3.1 op basis van graaddagen met een stookgrens van 16,5 °C. De berekening gaat ervan uit dat 80% van het gas- en warmteverbruik wordt gebruikt voor ruimteverwarming."
  },
  "not available. select one or more complete calendar years with sufficient climate data.": {
    "en": "Not available. Select one or more complete calendar years with sufficient climate data.",
    "nl": "Niet beschikbaar. Selecteer een of meer volledige kalenderjaren met voldoende klimaatgegevens."
  },
  "not available. complete climate data and at least one heating degree day are required for the selected period.": {
    "en": "Not available. Complete climate data and at least one heating degree day are required for the selected period.",
    "nl": "Niet beschikbaar. Voor de geselecteerde periode zijn volledige klimaatgegevens en minimaal één graaddag nodig."
  },
  "not available. climate year normalization is available in month and year views.": {
    "en": "Not available. Climate year normalization is available in month and year views.",
    "nl": "Niet beschikbaar. Klimaatjaar normaliseren is beschikbaar in maand- en jaarweergaven."
  },
  "climate normalized weii": {
    "en": "Climate-normalized WEii",
    "nl": "Klimaatgenormaliseerde WEii"
  },
  "calculation period start": {
    "en": "Calculation period start",
    "nl": "Start berekeningsperiode"
  },
  "calculation period end": {
    "en": "Calculation period end",
    "nl": "Einde berekeningsperiode"
  },
  "reference weather station": {
    "en": "Reference weather station",
    "nl": "Referentieweerstation"
  },
  "weather station code": {
    "en": "Weather station code",
    "nl": "Weerstationcode"
  },
  "climate normalization applied": {
    "en": "Climate normalization applied",
    "nl": "Klimaatnormalisatie toegepast"
  },
  "climate degree days": {
    "en": "Climate degree days",
    "nl": "Graaddagen klimaatnormalisatie"
  },
  "climate normalization degree days": {
    "en": "Climate normalization degree days",
    "nl": "Graaddagen klimaatnormalisatie"
  },
  "reference degree days": {
    "en": "Reference degree days",
    "nl": "Referentiegraaddagen"
  },
  "heating share assumption": {
    "en": "Heating share assumption",
    "nl": "Aanname verwarmingsaandeel"
  },
  "climate correction factor": {
    "en": "Climate correction factor",
    "nl": "Klimaatcorrectiefactor"
  },
  "climate correction": {
    "en": "Climate correction",
    "nl": "Klimaatcorrectie"
  },
  "normalized gas component": {
    "en": "Normalized gas component",
    "nl": "Genormaliseerde gascomponent"
  },
  "normalized heat component": {
    "en": "Normalized heat component",
    "nl": "Genormaliseerde warmtecomponent"
  },
  "not available. the required climate data is missing for this calculation.": {
    "en": "Not available. The required climate data is missing for this calculation.",
    "nl": "Niet beschikbaar. Voor deze berekening ontbreken de benodigde klimaatgegevens."
  },
  "not available. climate normalization is not possible for a full electric building.": {
    "en": "Not available. Climate normalization is not possible for a Full Electric building.",
    "nl": "Niet beschikbaar. Klimaatnormalisatie is niet mogelijk voor een Full Electric-pand."
  },
  "this building is classified as full electric. the weii score is therefore calculated using electricity data only.": {
    "en": "This building is classified as Full Electric. The WEii score is therefore calculated using electricity data only.",
    "nl": "Dit pand is als Full Electric geclassificeerd. Voor de WEii-scoreberekeningen wordt daarom uitsluitend rekening gehouden met elektriciteitsdata."
  },
  "enable full electric": {
    "en": "Enable Full Electric",
    "nl": "Full Electric inschakelen"
  },
  "please note: you have indicated that this building is full electric, but gas and/or heat connections are linked to this location. by enabling full electric, all weii scores will from now on be calculated without gas, heat or cooling data.": {
    "en": "Please note: you have indicated that this building is Full Electric, but gas and/or heat connections are linked to this location. By enabling Full Electric, all WEii scores will from now on be calculated without gas, heat or cooling data.",
    "nl": "Let op: je hebt aangegeven dat dit pand Full Electric is, maar er zijn gas- en/of warmteaansluitingen aan deze locatie gekoppeld. Door Full Electric in te schakelen, worden alle WEii-scores vanaf nu zonder gas-, warmte- of koudedata berekend."
  },
  "this building is classified as full electric. heat and cooling values in gj are therefore automatically excluded from the weii calculation to prevent double counting.": {
    "en": "This building is classified as Full Electric. Heat and cooling values in GJ are therefore automatically excluded from the WEii calculation to prevent double counting.",
    "nl": "Dit gebouw is als Full Electric geclassificeerd. Warmte- en koudewaarden in GJ zijn daarom automatisch buiten de WEii-berekening gehouden om dubbeltelling te voorkomen."
  },
  "weii calculation": {
    "en": "WEii calculation",
    "nl": "WEii-berekening"
  },
  "weii calculation settings": {
    "en": "WEii calculation settings",
    "nl": "Instellingen voor WEii-berekening"
  },
  "apply ev charging correction": {
    "en": "Apply EV charging correction",
    "nl": "Correctie voor laadverbruik toepassen"
  },
  "subtract separately metered ev charging from net electricity consumption.": {
    "en": "Subtract separately metered EV charging from net electricity consumption.",
    "nl": "Trek afzonderlijk gemeten laadverbruik af van het netto elektriciteitsgebruik."
  },
  "no complete ev charging data is available for the full calculation period.": {
    "en": "No complete EV charging data is available for the full calculation period.",
    "nl": "Voor de volledige berekeningsperiode is geen complete laadpaaldata beschikbaar."
  },
  "ev charging corrected": {
    "en": "EV charging corrected",
    "nl": "Laadpaal gecorrigeerd"
  },
  "information about ev charging correction": {
    "en": "Information about EV charging correction",
    "nl": "Informatie over laadpaalcorrectie"
  },
  "separately metered ev charging is subtracted from net electricity consumption. correction is only available when the full selected period is covered.": {
    "en": "Separately metered EV charging is subtracted from net electricity consumption. Correction is only available when the full selected period is covered.",
    "nl": "Afzonderlijk gemeten laadverbruik wordt afgetrokken van het netto elektriciteitsverbruik. De correctie is alleen beschikbaar wanneer de volledige gekozen periode is gedekt."
  },
  "complete ev charging data is missing for this period.": {
    "en": "Complete EV charging data is missing for this period.",
    "nl": "Voor deze periode ontbreekt volledige laadpaaldata."
  },
  "standard weii:": {
    "en": "Standard WEii:",
    "nl": "Standaard-WEii:"
  },
  "excluded charging consumption:": {
    "en": "Excluded charging consumption:",
    "nl": "Uitgesloten laadverbruik:"
  },
  "corrected weii:": {
    "en": "Corrected WEii:",
    "nl": "Gecorrigeerde WEii:"
  },
  "distance to paris proof:": {
    "en": "Distance to Paris Proof:",
    "nl": "Afstand tot Parijs Akkoord:"
  },
  "full-electric calculation: heat and cooling in gj are shown but excluded from the score.": {
    "en": "Full-electric calculation: heat and cooling in GJ are shown but excluded from the score.",
    "nl": "Full-electricberekening: warmte en koude in GJ worden getoond, maar niet in de score meegenomen."
  },
  "calculation variant": {
    "en": "Calculation variant",
    "nl": "Berekeningsvariant"
  },
  "ev-corrected": {
    "en": "EV-corrected",
    "nl": "Gecorrigeerd voor laadverbruik"
  },
  "standard weii": {
    "en": "Standard WEii",
    "nl": "Standaard-WEii"
  },
  "weii indicative": {
    "en": "WEii indicative",
    "nl": "WEii indicatief"
  },
  "excluded charging consumption": {
    "en": "Excluded charging consumption",
    "nl": "Uitgesloten laadverbruik"
  },
  "full-electric": {
    "en": "Full-electric",
    "nl": "Full-electric"
  },
  "excluded gas": {
    "en": "Excluded gas",
    "nl": "Uitgesloten gas"
  },
  "excluded heat": {
    "en": "Excluded heat",
    "nl": "Uitgesloten warmte"
  },
  "excluded cooling": {
    "en": "Excluded cooling",
    "nl": "Uitgesloten koude"
  },
  "gross electricity production": {
    "en": "Gross electricity production",
    "nl": "Bruto elektriciteitsproductie"
  },
  "directly self-consumed electricity": {
    "en": "Directly self-consumed electricity",
    "nl": "Direct zelf verbruikte elektriciteit"
  },
  "net electricity consumption": {
    "en": "Net electricity consumption",
    "nl": "Netto afname"
  },
  "adjusted electricity component": {
    "en": "Adjusted electricity component",
    "nl": "Aangepaste elektriciteitscomponent"
  },
  "onsite generation included": {
    "en": "Onsite generation included",
    "nl": "Eigen opwek meegenomen"
  },
  "ev charging excluded": {
    "en": "EV charging excluded",
    "nl": "Laadverbruik uitgesloten"
  },
  "onsite generation not applied": {
    "en": "Onsite generation not applied",
    "nl": "Eigen opwek niet toegepast"
  },
  "ev charging exclusion not applied": {
    "en": "EV charging exclusion not applied",
    "nl": "Uitsluiten laadverbruik niet toegepast"
  },
  "climate normalization not applied": {
    "en": "Climate normalization not applied",
    "nl": "Klimaatnormalisatie niet toegepast"
  },
  "locations have suitable data": {
    "en": "locations have suitable data",
    "nl": "locaties hebben geschikte data"
  },
  "no usable floor area available.": {
    "en": "No usable floor area available.",
    "nl": "Geen bruikbare oppervlakte beschikbaar."
  },
  "this location is marked as full-electric. available gas values are therefore excluded from the score.": {
    "en": "This location is marked as full-electric. Available gas values are therefore excluded from the score.",
    "nl": "Deze locatie is als full-electric aangemerkt. Beschikbare gaswaarden worden daarom niet in de score meegenomen."
  },
  "this location is marked as full-electric. available heat and cooling values in gj are therefore excluded from the score.": {
    "en": "This location is marked as full-electric. Available heat and cooling values in GJ are therefore excluded from the score.",
    "nl": "Deze locatie is als full-electric aangemerkt. Beschikbare warmte- en koudewaarden in GJ worden daarom niet in de score meegenomen."
  },
  "the measured ev charging consumption is invalid. the ev correction was not applied.": {
    "en": "The measured EV charging consumption is invalid. The EV correction was not applied.",
    "nl": "Het gemeten laadverbruik is ongeldig. De laadpaalcorrectie is niet toegepast."
  },
  "intermediate meters": {
    "en": "Intermediate meters",
    "nl": "Tussenmeters"
  },
  "download and update the names and standard fields of the intermediate meters linked to this electricity connection.": {
    "en": "Download and update the names and standard fields of the intermediate meters linked to this electricity connection.",
    "nl": "Download en wijzig de namen en standaardvelden van de tussenmeters die aan deze elektriciteitsaansluiting zijn gekoppeld."
  },
  "download intermediate meters": {
    "en": "Download intermediate meters",
    "nl": "Tussenmeters downloaden"
  },
  "upload intermediate meters": {
    "en": "Upload intermediate meters",
    "nl": "Tussenmeters uploaden"
  },
  "no intermediate meters are linked to this electricity connection.": {
    "en": "No intermediate meters are linked to this electricity connection.",
    "nl": "Aan deze elektriciteitsaansluiting zijn geen tussenmeters gekoppeld."
  },
  "no intermediate meters are selected for download.": {
    "en": "No intermediate meters are selected for download.",
    "nl": "Er zijn geen tussenmeters geselecteerd om te downloaden."
  },
  "source meter number": {
    "en": "Source meter number",
    "nl": "Bronmeternummer"
  },
  "managed by the source system and cannot be edited.": {
    "en": "Managed by the source system and cannot be edited.",
    "nl": "Wordt beheerd door het bronsysteem en kan niet worden aangepast."
  },
  "primary meter details are managed from the connection.": {
    "en": "Primary meter details are managed from the connection.",
    "nl": "Gegevens van de hoofdmeter worden beheerd vanuit de aansluiting."
  },
  "additional meter numbers": {
    "en": "Additional meter numbers",
    "nl": "Aanvullende meternummers"
  },
  "wing": {
    "en": "Wing",
    "nl": "Vleugel"
  },
  "intermediate meter metadata was updated successfully.": {
    "en": "Intermediate meter metadata was updated successfully.",
    "nl": "De gegevens van de tussenmeters zijn bijgewerkt."
  },
  "ev charging consumption exceeds net electricity consumption. the ev correction was not applied.": {
    "en": "EV charging consumption exceeds net electricity consumption. The EV correction was not applied.",
    "nl": "Het laadverbruik is groter dan het netto elektriciteitsgebruik. De laadpaalcorrectie is niet toegepast."
  },
  "new location – find address": {
    "en": "New location – find address",
    "nl": "Nieuwe locatie – adres zoeken"
  },
  "enter the postcode and house number to retrieve the address, coordinates and available energy-label data.": {
    "en": "Enter the postcode and house number to retrieve the address, coordinates and available energy-label data.",
    "nl": "Vul de postcode en het huisnummer in om het adres, de coördinaten en beschikbare energielabelgegevens op te halen."
  },
  "searching address…": {
    "en": "Searching address…",
    "nl": "Adres zoeken…"
  },
  "retrieving bag address data…": {
    "en": "Retrieving BAG address data…",
    "nl": "BAG-adresgegevens ophalen…"
  },
  "ep-online starts after bag": {
    "en": "EP-Online starts after BAG",
    "nl": "EP-Online start zodra BAG klaar is"
  },
  "bag address data found": {
    "en": "BAG address data found",
    "nl": "BAG-adresgegevens gevonden"
  },
  "retrieving energy label…": {
    "en": "Retrieving energy label…",
    "nl": "Energielabel ophalen…"
  },
  "no exact address was found. check the details or continue with manual entry.": {
    "en": "No exact address was found. Check the details or continue with manual entry.",
    "nl": "Er is geen exact adres gevonden. Controleer de gegevens of ga verder met handmatige invoer."
  },
  "the address service is temporarily unavailable. try again or continue with manual entry.": {
    "en": "The address service is temporarily unavailable. Try again or continue with manual entry.",
    "nl": "De adresservice is tijdelijk niet beschikbaar. Probeer het opnieuw of ga verder met handmatige invoer."
  },
  "address found": {
    "en": "Address found",
    "nl": "Adres gevonden"
  },
  "coordinates found": {
    "en": "Coordinates found",
    "nl": "Coördinaten gevonden"
  },
  "bag addressable object id found": {
    "en": "BAG addressable object ID found",
    "nl": "Verblijfsobject-ID gevonden"
  },
  "ep-online linked": {
    "en": "EP-Online linked",
    "nl": "EP-Online gekoppeld"
  },
  "no energy label was found in ep-online": {
    "en": "No energy label was found in EP-Online",
    "nl": "Er is geen energielabel gevonden in EP-Online"
  },
  "ep-online is temporarily unavailable and will be tried again after saving": {
    "en": "EP-Online is temporarily unavailable and will be tried again after saving",
    "nl": "EP-Online is tijdelijk niet beschikbaar en wordt na het opslaan opnieuw geprobeerd"
  },
  "ep-online is not configured in flowmaps": {
    "en": "EP-Online is not configured in Flowmaps",
    "nl": "EP-Online is niet geconfigureerd in Flowmaps"
  },
  "ep-online rejected the configured api key": {
    "en": "EP-Online rejected the configured API key",
    "nl": "EP-Online heeft de geconfigureerde API-sleutel geweigerd"
  },
  "ep-online returned an invalid response": {
    "en": "EP-Online returned an invalid response",
    "nl": "EP-Online heeft een ongeldig antwoord teruggegeven"
  },
  "ep-online could not be reached from flowmaps": {
    "en": "EP-Online could not be reached from Flowmaps",
    "nl": "EP-Online kon vanuit Flowmaps niet worden bereikt"
  },
  "address automatically filled using pdok": {
    "en": "Address automatically filled using PDOK",
    "nl": "Adres automatisch ingevuld via PDOK"
  },
  "change address": {
    "en": "Change address",
    "nl": "Adres wijzigen"
  },
  "enter manually": {
    "en": "Enter manually",
    "nl": "Handmatig invullen"
  },
  "find address": {
    "en": "Find address",
    "nl": "Adres zoeken"
  },
  "use these details": {
    "en": "Use these details",
    "nl": "Gegevens overnemen"
  },
  "coordinates automatically filled": {
    "en": "Coordinates automatically filled",
    "nl": "Coördinaten automatisch ingevuld"
  },
  "view": {
    "en": "View",
    "nl": "Bekijken"
  },
  "edit manually": {
    "en": "Edit manually",
    "nl": "Handmatig aanpassen"
  },
  "display options": {
    "en": "Display options",
    "nl": "Weergaveopties"
  },
  "visible": {
    "en": "Visible",
    "nl": "Zichtbaar"
  },
  "gross production meter (bpm)": {
    "en": "Gross production meter (BPM)",
    "nl": "Brutoproductiemeter (BPM)"
  },
  "unallocated consumption": {
    "en": "Unallocated consumption",
    "nl": "Niet-toegewezen verbruik"
  },
  "the calculated remainder can only be shown or hidden.": {
    "en": "The calculated remainder can only be shown or hidden.",
    "nl": "Het berekende restverbruik kan alleen zichtbaar of verborgen worden."
  },
  "this classification is managed by the active data source.": {
    "en": "This classification is managed by the active data source.",
    "nl": "Deze classificatie wordt beheerd door de actieve databron."
  },
  "use both sources": {
    "en": "Use both sources",
    "nl": "Beide bronnen gebruiken"
  },
  "existing production meter found": {
    "en": "Existing production meter found",
    "nl": "Bestaande productiemeter gevonden"
  },
  "an active bpm is already linked. choose how you want to process this meter.": {
    "en": "An active BPM is already linked. Choose how you want to process this meter.",
    "nl": "Er is al een actieve BPM gekoppeld. Kies hoe je deze meter wilt verwerken."
  },
  "save hidden": {
    "en": "Save hidden",
    "nl": "Verborgen opslaan"
  },
  "add both bpms": {
    "en": "Add both BPMs",
    "nl": "Beide BPM's optellen"
  },
  "make bpm visible": {
    "en": "Make BPM visible",
    "nl": "BPM zichtbaar maken"
  },
  "another active bpm already exists. how do you want to make this meter visible?": {
    "en": "Another active BPM already exists. How do you want to make this meter visible?",
    "nl": "Er is al een andere actieve BPM. Hoe wil je deze meter zichtbaar maken?"
  },
  "show as intermediate meter": {
    "en": "Show as intermediate meter",
    "nl": "Als tussenmeter tonen"
  },
  "existing charge point data found": {
    "en": "Existing charge point data found",
    "nl": "Bestaande laadpaaldata gevonden"
  },
  "active charge point data is already linked. choose how you want to process this meter.": {
    "en": "Active charge point data is already linked. Choose how you want to process this meter.",
    "nl": "Er is al actieve laadpaaldata gekoppeld. Kies hoe je deze meter wilt verwerken."
  },
  "make charge point meter visible": {
    "en": "Make charge point meter visible",
    "nl": "Laadpaalmeter zichtbaar maken"
  },
  "active charge point data is already linked. how do you want to make this meter visible?": {
    "en": "Active charge point data is already linked. How do you want to make this meter visible?",
    "nl": "Er is al actieve laadpaaldata gekoppeld. Hoe wil je deze meter zichtbaar maken?"
  },
  "charge points total": {
    "en": "Charge points total",
    "nl": "Laadpalen totaal"
  },
  "use multiple meter sources": {
    "en": "Use multiple meter sources",
    "nl": "Meerdere meterbronnen gebruiken"
  },
  "gross production meter": {
    "en": "Gross production meter",
    "nl": "Brutoproductiemeter"
  },
  "charge point meter": {
    "en": "Charge point meter",
    "nl": "Laadpaalmeter"
  },
  "an active gross production source is already linked. if you continue, both sources will be added together.": {
    "en": "An active gross production source is already linked. If you continue, both sources will be added together.",
    "nl": "Er is al een actieve brutoproductiebron gekoppeld. Als je doorgaat, worden beide bronnen bij elkaar opgeteld."
  },
  "active charge point data is already linked. if you continue, both sources will be added together.": {
    "en": "Active charge point data is already linked. If you continue, both sources will be added together.",
    "nl": "Er is al actieve laadpaaldata gekoppeld. Als je doorgaat, worden beide bronnen bij elkaar opgeteld."
  },
  "active gross production data is already linked. if you continue, source data and manually classified meters will be added together.": {
    "en": "Active gross production data is already linked. If you continue, source data and manually classified meters will be added together.",
    "nl": "Er is al actieve brutoproductiedata gekoppeld. Als je doorgaat, worden brondata en handmatig geclassificeerde meters bij elkaar opgeteld."
  },
  "active charge point data is already linked. if you continue, source data and manually classified meters will be added together.": {
    "en": "Active charge point data is already linked. If you continue, source data and manually classified meters will be added together.",
    "nl": "Er is al actieve laadpaaldata gekoppeld. Als je doorgaat, worden brondata en handmatig geclassificeerde meters bij elkaar opgeteld."
  },
  "active gross production and charge point data are already linked. if you continue, source data and manually classified meters will be added together.": {
    "en": "Active gross production and charge point data are already linked. If you continue, source data and manually classified meters will be added together.",
    "nl": "Er zijn al actieve bruto-productie- en laadpaaldata gekoppeld. Als je doorgaat, worden brondata en handmatig geclassificeerde meters bij elkaar opgeteld."
  },
  "hidden from charts and calculations": {
    "en": "Hidden from charts and calculations",
    "nl": "Verborgen in grafieken en berekeningen"
  },
  "available intervals": {
    "en": "available intervals",
    "nl": "beschikbare intervallen"
  },
  "quarter-hour data": {
    "en": "quarter-hour data",
    "nl": "kwartierdata"
  },
  "hourly data": {
    "en": "hourly data",
    "nl": "uurdata"
  },
  "daily data": {
    "en": "daily data",
    "nl": "dagdata"
  },
  "monthly data": {
    "en": "monthly data",
    "nl": "maanddata"
  },
  "yearly data": {
    "en": "yearly data",
    "nl": "jaardata"
  },
  "charging consumption excel comment": {
    "en": "Aggregated consumption of the connected charge points. This is part of total electricity consumption and should not be added to the total again.",
    "nl": "Gesommeerd verbruik van de gekoppelde laadpalen. Dit is onderdeel van het totale elektriciteitsverbruik en mag niet opnieuw bij het totaal worden opgeteld."
  },
  "measurement type": {
    "en": "Measurement type",
    "nl": "Meetsoort"
  },
  "measurement unit": {
    "en": "Measurement unit",
    "nl": "Eenheid"
  },
  "type meter": {
    "en": "Meter type",
    "nl": "Metertype"
  },
  "ean": {
    "en": "EAN",
    "nl": "EAN"
  },
  "surveyor": {
    "en": "Metering company",
    "nl": "Meetbedrijf"
  },
  "submeter total": {
    "en": "Submeter total",
    "nl": "Totaal tussenmeters"
  },
  "share of total": {
    "en": "Share of total",
    "nl": "Aandeel van totaal"
  },
  "total": {
    "en": "Total",
    "nl": "Totaal"
  },
  "charge point data": {
    "en": "Charge points",
    "nl": "Laadpalen"
  },
  "closed": {
    "en": "Closed",
    "nl": "Gesloten"
  },
  "days you do not change use the standard hours for the selected building type.": {
    "en": "Days you do not change use the standard hours for the selected building type.",
    "nl": "Dagen die je niet aanpast gebruiken de standaardtijden van het geselecteerde gebouwtype."
  },
  "enter both times and make sure they are not the same": {
    "en": "Enter both times and make sure they are not the same",
    "nl": "Vul beide tijden in en zorg dat ze niet gelijk zijn"
  },
  "no opening hours are configured for this location or building type": {
    "en": "No opening hours are configured for this location or building type",
    "nl": "Voor deze locatie of dit gebouwtype zijn geen openingstijden ingesteld"
  },
  "these opening hours will not be saved; this day returns to the building-type default.": {
    "en": "These opening hours will not be saved; this day returns to the building-type default.",
    "nl": "Deze openingstijden worden niet opgeslagen; deze dag valt terug op de standaard van het gebouwtype."
  },
  "some opening hours were not saved. incomplete days have returned to the building-type defaults.": {
    "en": "Some opening hours were not saved. Incomplete days have returned to the building-type defaults.",
    "nl": "Let op: sommige openingstijden zijn niet opgeslagen. Onvolledig ingevulde dagen zijn teruggevallen op de standaardtijden van het gebouwtype."
  },
  "discard opening-hour changes?": {
    "en": "Discard opening-hour changes?",
    "nl": "Aangepaste openingstijden weggooien?"
  },
  "the adjusted opening hours have not been saved. if you close this window, those days will return to the building-type defaults.": {
    "en": "The adjusted opening hours have not been saved. If you close this window, those days will return to the building-type defaults.",
    "nl": "De aangepaste openingstijden zijn niet opgeslagen. Als je dit venster sluit, vallen die dagen terug op de standaardtijden van het gebouwtype."
  },
  "discard changes": {
    "en": "Discard changes",
    "nl": "Wijzigingen weggooien"
  },
  "weii class": {
    "en": "WEii class",
    "nl": "WEii-klasse"
  },
  "weii score": {
    "en": "WEii score",
    "nl": "WEii-score"
  },
  "compared weii score": {
    "en": "Compared WEii score",
    "nl": "Vergelijkingsscore"
  },
  "years": {
    "en": "Years",
    "nl": "Jaren"
  },
  "difference": {
    "en": "Difference",
    "nl": "Verschil"
  },
  "development": {
    "en": "Development",
    "nl": "Ontwikkeling"
  },
  "stable": {
    "en": "Stable",
    "nl": "Stabiel"
  },
  "savings": {
    "en": "Savings",
    "nl": "Besparing"
  },
  "increase": {
    "en": "Increase",
    "nl": "Stijging"
  },
  "crrem_pathway": {
    "en": "CRREM pathway",
    "nl": "CRREM-pad"
  },
  "crrem_metric": {
    "en": "CRREM metric",
    "nl": "CRREM-maatstaf"
  },
  "crrem_energy": {
    "en": "Energy",
    "nl": "Energie"
  },
  "crrem_loading": {
    "en": "Loading CRREM assessment…",
    "nl": "CRREM-beoordeling laden…"
  },
  "crrem_failed": {
    "en": "CRREM data could not be loaded. Reopen the widget to retry.",
    "nl": "CRREM-gegevens konden niet worden geladen. Open de weergave opnieuw."
  },
  "crrem_intensity": {
    "en": "Building intensity",
    "nl": "Gebouwintensiteit"
  },
  "crrem_target": {
    "en": "CRREM target",
    "nl": "CRREM-doelwaarde"
  },
  "crrem_crossing": {
    "en": "Misalignment year",
    "nl": "Overschrijdingsjaar"
  },
  "crrem_provisional": {
    "en": "Provisional",
    "nl": "Voorlopig"
  },
  "crrem_constant_demand": {
    "en": "Constant energy demand",
    "nl": "Gelijkblijvend energiegebruik"
  },
  "crrem_chart_description": {
    "en": "Historical building intensity and future projection against the CRREM pathway until 2050",
    "nl": "Historische gebouwintensiteit en toekomstprojectie tegenover het CRREM-pad tot 2050"
  },
  "crrem_measured_years": {
    "en": "Available reporting years",
    "nl": "Beschikbare meetjaren"
  },
  "crrem_projection": {
    "en": "Projection",
    "nl": "Projectie"
  },
  "crrem_base_year": {
    "en": "Base year",
    "nl": "Basisjaar"
  },
  "crrem_no_years": {
    "en": "No completed reporting years with energy data are available.",
    "nl": "Er zijn geen afgesloten meetjaren met energiegegevens beschikbaar."
  },
  "crrem_provisional_details": {
    "en": "Provisional · data and assumptions (i)",
    "nl": "Voorlopig · gegevens en aannames"
  },
  "crrem_calculation_details": {
    "en": "Calculation details",
    "nl": "Berekeningsdetails"
  },
  "crrem_partial_impact": {
    "nl": "De uitkomst kan hierdoor afwijken. Ontbrekend verbruik kan de uitstoot te laag en het overschrijdingsjaar te gunstig inschatten.",
    "en": "This may affect the result. Missing consumption can understate emissions and delay the estimated misalignment year."
  },
  "crrem_area": {
    "en": "Floor area",
    "nl": "Oppervlakte"
  },
  "crrem_unmapped": {
    "en": "Building type not mapped",
    "nl": "Gebouwtype nog niet gekoppeld"
  },
  "crrem_months": {
    "nl": "Maanden met stroomdata",
    "en": "Months with electricity data"
  },
  "crrem_boundary": {
    "nl": "Gebaseerd op hoofdmeterdata.",
    "en": "Based on main meter data."
  },
  "crrem_all_electric": {
    "en": "All-electric: electricity only; no gas or internal heat/cooling.",
    "nl": "All-electric: alleen elektriciteit; geen gas of interne warmte/koude."
  },
  "crrem_thermal_rule": {
    "en": "Electricity, gas and purchased heat/cooling. Internal generation is not counted separately.",
    "nl": "Elektriciteit, gas en ingekochte warmte/koude. Interne productie telt niet apart mee."
  },
  "crrem_assumptions": {
    "nl": "De projectie gaat uit van gelijkblijvend verbruik en de verwachte verduurzaming van de elektriciteitsmix in {country}, volgens CRREM. De vergelijking volgt het 1,5°C-pad, zonder F-gassen, oppervlakte- of weercorrectie.",
    "en": "The projection assumes constant energy use and the expected decarbonisation of the electricity mix in {country}, following CRREM. The comparison uses the 1.5°C pathway, excluding F-gases, with no area or weather adjustment."
  },
  "crrem_missing_area": {
    "en": "A valid floor area is missing; intensity cannot be calculated.",
    "nl": "Een geldig oppervlak ontbreekt; de intensiteit kan niet worden berekend."
  },
  "crrem_missing_region": {
    "en": "No supported national CRREM dataset is available for this country. Sub-national regions require a postal-code mapping.",
    "nl": "Geen ondersteunde nationale CRREM-dataset voor dit land. Subnationale regio’s vereisen een postcodekoppeling."
  },
  "crrem_missing_type": {
    "en": "No matching CRREM pathway has been assigned to this building type.",
    "nl": "Voor dit gebouwtype is nog geen passend CRREM-pad gekoppeld."
  },
  "crrem_invalid_values": {
    "en": "Invalid or negative consumption values were excluded; check meter corrections.",
    "nl": "Ongeldige of negatieve verbruikswaarden zijn uitgesloten; controleer de metercorrecties."
  },
  "crrem_incomplete_electricity": {
    "en": "Electricity data does not cover all 12 months. The available total is not extrapolated.",
    "nl": "Elektriciteitsdata dekt niet alle 12 maanden. Het beschikbare totaal wordt niet geëxtrapoleerd."
  },
  "crrem_missing_heat": {
    "nl": "Gas- of warmtegegevens ontbreken; de berekende uitstoot kan te laag zijn.",
    "en": "Gas or heat data is missing; calculated emissions may be understated."
  },
  "crrem_incomplete_thermal": {
    "en": "Gas, heat or cooling data is missing for part of this year.",
    "nl": "Gas-, warmte- of koudedata ontbreekt voor een deel van dit jaar."
  },
  "crrem_electric_gas_conflict": {
    "en": "Gas consumption is present despite the all-electric setting. It is excluded; check the building setting.",
    "nl": "Er is gasverbruik ondanks de all-electricinstelling. Dit is uitgesloten; controleer de gebouwinstelling."
  },
  "crrem_missing_production": {
    "en": "Generation is indicated, but gross production data does not cover the full year. Self-consumed generation may be understated.",
    "nl": "Er zijn aanwijzingen voor opwek, maar bruto productiedata dekt niet het hele jaar. Eigen verbruikte opwek kan zijn onderschat."
  },
  "crrem_export_exceeds_production": {
    "en": "Export exceeds measured production. Check the generation meters, period and possible battery operation.",
    "nl": "Teruglevering is hoger dan de gemeten productie. Controleer productiemeters, periode en eventuele batterijwerking."
  },
  "crrem_estimated": {
    "en": "Some values are estimated or allocated from coarser reporting periods.",
    "nl": "Een deel van de waarden is geschat of verdeeld vanuit grovere meetperioden."
  },
  "crrem_thermal_factor_estimated": {
    "en": "Heat/cooling: estimated emission factor. Heat follows the grid; cooling stays constant. Supplier factor missing.",
    "nl": "Warmte/koude: emissiefactor geschat. Warmte volgt het net; koude blijft gelijk. Leveranciersfactor ontbreekt."
  },
  "crrem_coverage_unknown": {
    "en": "Meter-level completeness could not be established.",
    "nl": "Volledigheid per meter kon niet worden vastgesteld."
  },
  "crrem_meter_gaps": {
    "en": "At least one relevant meter has gaps in the reporting year.",
    "nl": "Minstens één relevante meter heeft hiaten in het meetjaar."
  },
  "crrem_generation_unconfirmed": {
    "en": "No generation recorded or included. Solar panel presence unknown.",
    "nl": "Geen opwek geregistreerd of meegerekend. Aanwezigheid van zonnepanelen onbekend."
  },
  "energy compass view": {
    "en": "Energy compass view",
    "nl": "Energiekompasweergave"
  },
  "crrem_year_unit": {
    "en": "year",
    "nl": "jaar"
  },
  "crrem_gas_conversion": {
    "nl": "Gas omgerekend met 9,78 kWh/m³.",
    "en": "Gas converted using 9.78 kWh/m³."
  },
  "crrem_close": {
    "nl": "Sluiten",
    "en": "Close"
  },
  "show projection": {
    "en": "Show projection",
    "nl": "Projectie tonen"
  },
  "mark exceedance year": {
    "en": "Mark exceedance year",
    "nl": "Overschrijdingsjaar markeren"
  },
  "show crrem target pathway": {
    "en": "Show CRREM target pathway",
    "nl": "CRREM-doellijn tonen"
  },
  "enlarge energy compass": {
    "en": "Enlarge energy compass",
    "nl": "Vergroot energiekompas"
  },
  "shrink energy compass": {
    "en": "Shrink energy compass",
    "nl": "Verklein energiekompas"
  },
  "crrem display options": {
    "en": "CRREM display options",
    "nl": "CRREM-weergaveopties"
  },
  "crrem_attention": {
    "en": "Points to check",
    "nl": "Aandachtspunten"
  },
  "crrem_building": {
    "en": "Building",
    "nl": "Gebouw"
  },
  "crrem_basis": {
    "en": "Calculation basis",
    "nl": "Rekenbasis"
  },
  "crrem_method_details": {
    "en": "Assumptions and source",
    "nl": "Uitgangspunten en bron"
  },
  "crrem_conversion_factors": {
    "en": "Conversion: gas 9.78 kWh/m³ · heat/cooling 277.778 kWh/GJ.",
    "nl": "Omrekening: gas 9,78 kWh/m³ · warmte/koude 277,778 kWh/GJ."
  },
  "crrem_months_short": {
    "en": "months",
    "nl": "maanden"
  },
  "netherlands": {
    "en": "Netherlands",
    "nl": "Nederland"
  },
  "crrem_month_coverage_note": {
    "nl": "Een maand telt mee zodra er data is. Dit bevestigt niet dat alle dagen of meetintervallen compleet zijn.",
    "en": "A month counts when data is present. This does not confirm that every day or measurement interval is complete."
  },
  "crrem_data_coverage": {
    "nl": "Maanden met data",
    "en": "Months with data"
  },
  "crrem_district_heat": {
    "nl": "Stadswarmte",
    "en": "District heating"
  },
  "crrem_cooling": {
    "nl": "Koude",
    "en": "Cooling"
  },
  "crrem_not_applicable_electric": {
    "nl": "N.v.t. · all-electric",
    "en": "N/A · all-electric"
  },
  "crrem_thermal_carrier": {
    "nl": "Gas / warmte",
    "en": "Gas / heat"
  },
  "crrem_no_carrier_data": {
    "nl": "Geen data",
    "en": "No data"
  },
  "crrem_indicative_title": {
    "nl": "Indicatieve CRREM-beoordeling",
    "en": "Indicative CRREM assessment"
  },
  "crrem_indicative_short": {
    "nl": "Indicatief",
    "en": "Indicative"
  },
  "crrem_indicative_description": {
    "nl": "Berekend met hoofdmeterdata en emissiefactoren. De stippellijn toont de verwachte ontwikkeling bij gelijkblijvend energiegebruik. Ontbrekende gegevens en aannames kunnen de uitkomst beïnvloeden.",
    "en": "Calculated using main meter data and emission factors. The dashed line shows the expected development with constant energy use. Missing data and assumptions may affect the result."
  },
  "crrem_heat_conversion": {
    "nl": "Warmte is omgerekend met 277,778 kWh/GJ.",
    "en": "Heat is converted using 277.778 kWh/GJ."
  },
  "crrem_methodology_hint": {
    "nl": "Klik hier voor meer informatie over de CRREM-berekeningsmethodiek.",
    "en": "Click here for more information about the CRREM calculation methodology."
  },
  "crrem_approximate_comparison": {
    "en": "Indicative comparison",
    "nl": "Indicatieve vergelijking"
  },
  "crrem_reference": {
    "en": "CRREM reference",
    "nl": "CRREM-referentie"
  },
  "crrem_approximate_description": {
    "en": "We use {pathway} as an approximate reference for this building type. The actual building use may differ. The reference line and exceedance year are therefore indicative.",
    "nl": "Voor dit gebouwtype gebruiken we {pathway} als benadering. De werkelijke gebouwfunctie kan afwijken. De referentielijn en het overschrijdingsjaar zijn daarom indicatief."
  },
  "residential single-family": {
    "en": "Residential Single-Family",
    "nl": "Eengezinswoningen"
  },
  "residential multi-family": {
    "en": "Residential Multi-Family",
    "nl": "Meergezinswoningen"
  },
  "retail high street": {
    "en": "Retail High Street",
    "nl": "Winkelstraat"
  },
  "shopping center": {
    "en": "Shopping Center",
    "nl": "Winkelcentrum"
  },
  "retail warehouse": {
    "en": "Retail Warehouse",
    "nl": "Grootschalige detailhandel"
  },
  "distribution warehouse cold": {
    "en": "Distribution Warehouse Cold",
    "nl": "Gekoeld distributiecentrum"
  },
  "distribution warehouse warm": {
    "en": "Distribution Warehouse Warm",
    "nl": "Verwarmd distributiecentrum"
  },
  "healthcare": {
    "en": "Healthcare",
    "nl": "Zorggebouw"
  },
  "leisure/lodging": {
    "en": "Leisure/Lodging",
    "nl": "Recreatie en verblijf"
  },
  "configure meter split": {
    "en": "Configure meter split",
    "nl": "Metersplitsing configureren"
  },
  "divide this meter's measurements among virtual child meters.": {
    "en": "Divide this meter's measurements among virtual child meters.",
    "nl": "Verdeel de metingen van deze meter over virtuele onderliggende meters."
  },
  "percentage": {
    "en": "Percentage",
    "nl": "Percentage"
  },
  "remove allocated meter": {
    "en": "Remove allocated meter",
    "nl": "Toegewezen meter verwijderen"
  },
  "add allocated meter": {
    "en": "Add allocated meter",
    "nl": "Toegewezen meter toevoegen"
  },
  "percentages must total 100% and use at most one decimal place.": {
    "en": "Percentages must total 100% and use at most one decimal place.",
    "nl": "De percentages moeten samen 100% zijn en mogen maximaal één decimaal hebben."
  },
  "remove meter split": {
    "en": "Remove meter split",
    "nl": "Metersplitsing verwijderen"
  },
  "this removes all allocated child meters and their authorisations. the source meter and its data remain unchanged.": {
    "en": "This removes all allocated child meters and their authorisations. The source meter and its data remain unchanged.",
    "nl": "Hiermee worden alle toegewezen onderliggende meters en hun autorisaties verwijderd. De bronmeter en de bijbehorende gegevens blijven ongewijzigd."
  },
  "are you sure you want to remove this meter split?": {
    "en": "Are you sure you want to remove this meter split?",
    "nl": "Weet je zeker dat je deze metersplitsing wilt verwijderen?"
  },
  "unsplit meter": {
    "en": "Unsplit meter",
    "nl": "Metersplitsing opheffen"
  },
  "climate normalized (provisional periods show actual consumption)": {
    "en": "Climate normalized (provisional periods show actual consumption)",
    "nl": "Klimaatgenormaliseerd (voorlopige perioden tonen werkelijk verbruik)"
  },
  "actual consumption (provisional period)": {
    "en": "Actual consumption (provisional period)",
    "nl": "Werkelijk verbruik (voorlopige periode)"
  },
  "climate normalization is applied to completed months and years. the current period still shows actual consumption.": {
    "en": "Climate normalization is applied to completed months and years. The current period still shows actual consumption.",
    "nl": "Klimaatnormalisatie wordt toegepast op afgeronde maanden en jaren. De lopende periode toont nog het werkelijke verbruik."
  },
  "refine the gas and heat display by normalizing climate-sensitive consumption to the weii 3.1 reference climate of 2,200 heating degree days. the calculation uses a 16.5 °c base temperature and assumes that 80% of gas and heat consumption is used for space heating. this allows different periods to be compared more fairly. enable this option only when that assumption is appropriate for the selected buildings. one correction factor is calculated over the completed part of the selected period. provisional periods continue to show actual consumption and are identified as provisional. climate year normalization is available in month and year views.": {
    "en": "Refine the gas and heat display by normalizing climate-sensitive consumption to the WEii 3.1 reference climate of 2,200 heating degree days. The calculation uses a 16.5 °C base temperature and assumes that 80% of gas and heat consumption is used for space heating. This allows different periods to be compared more fairly. Enable this option only when that assumption is appropriate for the selected buildings. One correction factor is calculated over the completed part of the selected period. Provisional periods continue to show actual consumption and are identified as provisional. Climate year normalization is available in month and year views.",
    "nl": "Verfijn de weergave van gas en warmte door klimaatgevoelig verbruik te normaliseren naar het referentieklimaat uit WEii 3.1 van 2.200 graaddagen. De berekening gebruikt een stookgrens van 16,5 °C en gaat ervan uit dat 80% van het gas- en warmteverbruik voor ruimteverwarming wordt gebruikt. Zo kunnen verschillende perioden eerlijker met elkaar worden vergeleken. Gebruik deze optie alleen als die aanname passend is voor de geselecteerde panden. Eén correctiefactor wordt berekend over het afgeronde deel van de geselecteerde periode. Voorlopige perioden blijven het werkelijke verbruik tonen en worden als voorlopig aangeduid. Klimaatjaar normaliseren is beschikbaar in maand- en jaarweergaven."
  },
  "save split": {
    "en": "Save split",
    "nl": "Splitsing opslaan"
  },
  "energy type": {
    "en": "Energy type",
    "nl": "Energietype"
  },
  "connect ennatuurlijk": {
    "en": "Connect Ennatuurlijk",
    "nl": "Ennatuurlijk koppelen"
  },
  "enter connection manually": {
    "en": "Enter connection manually",
    "nl": "Aansluiting handmatig invoeren"
  },
  "choose a meter and start date. flowmaps imports daily heat or cooling consumption in gj and updates it automatically.": {
    "en": "Choose a meter and start date. Flowmaps imports daily heat or cooling consumption in GJ and updates it automatically.",
    "nl": "Kies een meter en startdatum. Flowmaps haalt het dagelijkse warmte- of koudeverbruik in GJ op en werkt dit automatisch bij."
  },
  "loading ennatuurlijk meters": {
    "en": "Loading Ennatuurlijk meters",
    "nl": "Ennatuurlijk-meters laden"
  },
  "ennatuurlijk key not configured": {
    "en": "Ennatuurlijk key not configured",
    "nl": "De Ennatuurlijk-koppeling is nog niet ingesteld voor deze omgeving."
  },
  "no authorised ennatuurlijk meters available for this location": {
    "en": "No authorised Ennatuurlijk meters available for this location",
    "nl": "Geen toegestane Ennatuurlijk-meters voor deze locatie gevonden. Vraag de beheerder de aansluiting toe te wijzen."
  },
  "ennatuurlijk meter": {
    "en": "Ennatuurlijk meter",
    "nl": "Ennatuurlijk-meter"
  },
  "import from": {
    "en": "Import from",
    "nl": "Importeren vanaf"
  },
  "ennatuurlijk daily data uses dutch calendar days. missing days remain missing; daily totals do not provide measured peak power.": {
    "en": "Ennatuurlijk daily data uses Dutch calendar days. Missing days remain missing; daily totals do not provide measured peak power.",
    "nl": "De dagwaarden volgen Nederlandse kalenderdagen. Ontbrekende dagen blijven ontbrekend; dagtotalen leveren geen gemeten piekvermogen."
  },
  "ennatuurlijk import status": {
    "en": "Ennatuurlijk import status",
    "nl": "Status Ennatuurlijk-import"
  },
  "ennatuurlijk import pending": {
    "en": "Ennatuurlijk import pending",
    "nl": "Import staat klaar"
  },
  "ennatuurlijk importing history": {
    "en": "Ennatuurlijk importing history",
    "nl": "Historie wordt opgehaald"
  },
  "ennatuurlijk import up to date": {
    "en": "Ennatuurlijk import up to date",
    "nl": "Import bijgewerkt"
  },
  "ennatuurlijk missing days": {
    "en": "Ennatuurlijk missing days",
    "nl": "Import bijgewerkt; de gecontroleerde maand bevat ontbrekende dagen"
  },
  "ennatuurlijk import waiting": {
    "en": "Ennatuurlijk import waiting",
    "nl": "Import wacht op beschikbare API-ruimte"
  },
  "ennatuurlijk import failed": {
    "en": "Ennatuurlijk import failed",
    "nl": "Import niet gelukt; bekende gegevens zijn behouden"
  },
  "ennatuurlijk environment changed": {
    "en": "Ennatuurlijk environment changed",
    "nl": "Import gepauzeerd: de omgeving van deze aansluiting is gewijzigd"
  },
  "last checked month": {
    "en": "Last checked month",
    "nl": "Laatst gecontroleerde maand"
  },
  "missing days in checked month": {
    "en": "Missing days in checked month",
    "nl": "Ontbrekende dagen in die maand"
  },
  "last successful import": {
    "en": "Last successful import",
    "nl": "Laatste geslaagde import"
  },
  "refresh import status": {
    "en": "Refresh import status",
    "nl": "Importstatus vernieuwen"
  },
  "ennatuurlijk is busy. try again shortly.": {
    "en": "Ennatuurlijk is busy. Try again shortly.",
    "nl": "Ennatuurlijk is tijdelijk bezet. Probeer het zo opnieuw."
  },
  "this connection already has an active data source": {
    "en": "This connection already has an active data source",
    "nl": "Deze aansluiting heeft al een actieve gegevensbron. Beëindig eerst die koppeling om dubbeltelling te voorkomen."
  },
  "select one connection when multiple connections have the same code": {
    "en": "Select one connection when multiple connections have the same code",
    "nl": "Meerdere aansluitingen hebben dezelfde code. Selecteer eerst de bedoelde aansluiting voordat je verbruik uploadt."
  },
  "heating degree-day correction is not available for cooling consumption.": {
    "en": "Heating degree-day correction is not available for cooling consumption.",
    "nl": "Correctie met verwarmingsgraaddagen is niet beschikbaar voor koudeverbruik."
  },
  "choose an ennatuurlijk start date between 2000 and today": {
    "en": "Choose an Ennatuurlijk start date between 2000 and today",
    "nl": "Kies een startdatum tussen 2000 en vandaag."
  },
  "ennatuurlijk meter is unavailable": {
    "en": "Ennatuurlijk meter is unavailable",
    "nl": "Deze Ennatuurlijk-meter is niet beschikbaar."
  },
  "connection does not belong to this location": {
    "en": "Connection does not belong to this location",
    "nl": "De aansluiting hoort niet bij deze locatie."
  },
  "ennatuurlijk meter does not match this connection": {
    "en": "Ennatuurlijk meter does not match this connection",
    "nl": "De Ennatuurlijk-meter komt niet overeen met deze aansluiting."
  },
  "this ennatuurlijk connection already exists": {
    "en": "This Ennatuurlijk connection already exists",
    "nl": "Deze Ennatuurlijk-aansluiting bestaat al."
  },
  "this ennatuurlijk meter is already linked to another connection": {
    "en": "This Ennatuurlijk meter is already linked to another connection",
    "nl": "Deze Ennatuurlijk-meter is al aan een andere aansluiting gekoppeld."
  },
  "location does not belong to this organisation": {
    "en": "Location does not belong to this organisation",
    "nl": "De locatie hoort niet bij deze organisatie."
  },
  "invalid ennatuurlijk response; no measurements were imported": {
    "en": "Invalid Ennatuurlijk response; no measurements were imported",
    "nl": "Ennatuurlijk gaf een ongeldig antwoord. Er zijn geen meetgegevens geïmporteerd."
  },
  "ennatuurlijk is not available for this environment": {
    "en": "Ennatuurlijk is not available for this environment",
    "nl": "Ennatuurlijk is niet beschikbaar voor deze omgeving."
  },
  "ennatuurlijk api key is missing for this environment": {
    "en": "Ennatuurlijk API key is missing for this environment",
    "nl": "De Ennatuurlijk-koppeling is nog niet ingesteld voor deze omgeving."
  },
  "invalid ennatuurlijk meter binding": {
    "en": "Invalid Ennatuurlijk meter binding",
    "nl": "De Ennatuurlijk-meter is niet correct gekoppeld. Laat de beheerder dit controleren."
  },
  "invalid ennatuurlijk request": {
    "en": "Invalid Ennatuurlijk request",
    "nl": "De aanvraag voor Ennatuurlijk is ongeldig."
  },
  "ennatuurlijk request failed": {
    "en": "Ennatuurlijk request failed",
    "nl": "Het ophalen bij Ennatuurlijk is niet gelukt. Laat de beheerder de koppeling controleren."
  },
  "ennatuurlijk is temporarily unavailable": {
    "en": "Ennatuurlijk is temporarily unavailable",
    "nl": "Ennatuurlijk is tijdelijk niet bereikbaar."
  },
  "ennatuurlijk supports heat and cooling connections": {
    "en": "Ennatuurlijk supports heat and cooling connections",
    "nl": "Kies warmte of koude voor een Ennatuurlijk-aansluiting."
  },
  "no unique ennatuurlijk meter found for this ean and energy type": {
    "en": "No unique Ennatuurlijk meter found for this EAN and energy type",
    "nl": "Geen unieke Ennatuurlijk-meter gevonden voor deze EAN en dit energietype. Controleer de EAN, het type en de toegang in deze omgeving."
  },
  "show cooling": {
    "en": "Show cooling",
    "nl": "Koude tonen"
  },
  "heat and cooling consumption": {
    "en": "Heat and cooling consumption",
    "nl": "Warmte- en koudeverbruik"
  },
  "gas, heat and cooling consumption": {
    "en": "Gas, heat and cooling consumption",
    "nl": "Gas-, warmte- en koudeverbruik"
  },
  "monthly cooling consumption": {
    "en": "Monthly cooling consumption",
    "nl": "Koudeverbruik per maand"
  },
  "raw cooling consumption": {
    "en": "Raw cooling consumption",
    "nl": "Koudeverbruik per tijdvak"
  },
  "some existing measurement values will change. review these periods before approving the correction.": {
    "en": "Some existing measurement values will change. Review these periods before approving the correction.",
    "nl": "Bestaande meetwaarden worden gewijzigd. Controleer deze perioden voordat je de correctie toestaat."
  },
  "upload history": {
    "en": "Upload history",
    "nl": "Uploadhistorie"
  },
  "uploaded measurements, corrections and deleted periods": {
    "en": "Uploaded measurements, corrections and deleted periods",
    "nl": "Geüploade meetdata, correcties en verwijderde perioden"
  },
  "current volume": {
    "en": "Current volume",
    "nl": "Actueel volume"
  },
  "last processing": {
    "en": "Last processing",
    "nl": "Laatste verwerking"
  },
  "this upload meter": {
    "en": "This upload meter",
    "nl": "Deze uploadmeter"
  },
  "connections in the current selection": {
    "en": "Connections in the current selection",
    "nl": "Aansluitingen binnen de huidige selectie"
  },
  "older unregistered uploads are available by opening the upload meter at its connection.": {
    "en": "Older unregistered uploads are available by opening the upload meter at its connection.",
    "nl": "Eerdere uploads zonder registratie vind je door de uploadmeter bij de aansluiting te openen."
  },
  "more periods are available. narrow the connection selection.": {
    "en": "More periods are available. Narrow the connection selection.",
    "nl": "Er zijn meer perioden. Verklein de selectie van aansluitingen."
  },
  "no uploaded periods for this selection and year": {
    "en": "No uploaded periods for this selection and year",
    "nl": "Geen geüploade perioden voor deze selectie en dit jaar"
  },
  "original source unknown": {
    "en": "Original source unknown",
    "nl": "Oorspronkelijke bron onbekend"
  },
  "existing data": {
    "en": "Existing data",
    "nl": "Bestaande meetdata"
  },
  "delete period": {
    "en": "Delete period",
    "nl": "Periode verwijderen"
  },
  "restore period": {
    "en": "Restore period",
    "nl": "Periode herstellen"
  },
  "confirm period action": {
    "en": "Confirm period action",
    "nl": "Periodeactie bevestigen"
  },
  "delete this uploaded period?": {
    "en": "Delete this uploaded period?",
    "nl": "Deze geüploade periode verwijderen?"
  },
  "restore this uploaded period?": {
    "en": "Restore this uploaded period?",
    "nl": "Deze geüploade periode herstellen?"
  },
  "only this uploaded measurement series will be removed. the period becomes missing data, not zero consumption.": {
    "en": "Only this uploaded measurement series will be removed. The period becomes missing data, not zero consumption.",
    "nl": "Alleen deze geüploade meetreeks wordt verwijderd. De periode wordt ontbrekende data, geen nulverbruik."
  },
  "the snapshot saved when this period was deleted will be restored.": {
    "en": "The snapshot saved when this period was deleted will be restored.",
    "nl": "De meetwaarden die bij het verwijderen zijn bewaard worden hersteld."
  },
  "close details": {
    "en": "Close details",
    "nl": "Details sluiten"
  },
  "existing measurements. original file, uploader and upload time were not recorded.": {
    "en": "Existing measurements. Original file, uploader and upload time were not recorded.",
    "nl": "Bestaande meetdata. Het oorspronkelijke bestand, de uploader en het uploadmoment zijn niet vastgelegd."
  },
  "download original": {
    "en": "Download original",
    "nl": "Origineel downloaden"
  },
  "view value changes": {
    "en": "View value changes",
    "nl": "Gewijzigde waarden bekijken"
  },
  "the first 100 value changes are shown. the complete period snapshot is retained for recovery.": {
    "en": "The first 100 value changes are shown. The complete period snapshot is retained for recovery.",
    "nl": "De eerste 100 wijzigingen worden getoond. De volledige actuele periode blijft bewaard voor herstel bij verwijderen."
  },
  "newer uploads": {
    "en": "Newer uploads",
    "nl": "Nieuwere uploads"
  },
  "older uploads": {
    "en": "Older uploads",
    "nl": "Oudere uploads"
  },
  "upload history could not be loaded": {
    "en": "Upload history could not be loaded",
    "nl": "De uploadhistorie kon niet worden geladen"
  },
  "upload period deleted": {
    "en": "Upload period deleted",
    "nl": "Uploadperiode verwijderd"
  },
  "upload period restored": {
    "en": "Upload period restored",
    "nl": "Uploadperiode hersteld"
  },
  "measurement point": {
    "en": "measurement point",
    "nl": "meetpunt"
  },
  "measurement points": {
    "en": "measurement points",
    "nl": "meetpunten"
  },
  "processed": {
    "en": "Processed",
    "nl": "Verwerkt"
  },
  "corrected": {
    "en": "Corrected",
    "nl": "Gecorrigeerd"
  },
  "unchanged": {
    "en": "Unchanged",
    "nl": "Ongewijzigd"
  },
  "deleted": {
    "en": "Deleted",
    "nl": "Verwijderd"
  },
  "transferred": {
    "en": "Transferred",
    "nl": "Overgezet"
  },
  "restored": {
    "en": "Restored",
    "nl": "Hersteld"
  },
  "added": {
    "en": "added",
    "nl": "toegevoegd"
  },
  "changed": {
    "en": "changed",
    "nl": "gewijzigd"
  },
  "removed": {
    "en": "removed",
    "nl": "verwijderd"
  },
  "processing": {
    "en": "Processing",
    "nl": "Verwerken"
  },
  "previous": {
    "en": "Previous",
    "nl": "Vorige"
  },
  "the change is saved. measurements are still being updated; refresh shortly.": {
    "en": "The change is saved. Measurements are still being updated; refresh shortly.",
    "nl": "De wijziging is opgeslagen. De meetgegevens worden nog bijgewerkt; vernieuw over enkele ogenblikken."
  },
  "upload meter not found": {
    "en": "Upload meter not found",
    "nl": "Uploadmeter niet gevonden"
  },
  "upload period not found": {
    "en": "Upload period not found",
    "nl": "Uploadperiode niet gevonden"
  },
  "upload period changed; refresh and try again": {
    "en": "Upload period changed; refresh and try again",
    "nl": "De uploadperiode is gewijzigd. Vernieuw het overzicht en probeer opnieuw."
  },
  "upload period state changed; refresh and try again": {
    "en": "Upload period state changed; refresh and try again",
    "nl": "De status van de uploadperiode is gewijzigd. Vernieuw het overzicht en probeer opnieuw."
  },
  "no upload snapshot is available to restore": {
    "en": "No upload snapshot is available to restore",
    "nl": "Er zijn geen bewaarde uploadwaarden om te herstellen."
  },
  "this upload period was deleted; restore it explicitly before uploading again": {
    "en": "This upload period was deleted; restore it explicitly before uploading again",
    "nl": "Deze uploadperiode is verwijderd. Herstel de periode voordat je opnieuw uploadt."
  },
  "overlapping upload resolutions require review": {
    "en": "Overlapping upload resolutions require review",
    "nl": "Overlappende meetintervallen moeten eerst worden gecontroleerd."
  },
  "upload intervals must fit within one calendar month": {
    "en": "Upload intervals must fit within one calendar month",
    "nl": "Een meetinterval moet binnen één kalendermaand vallen."
  },
  "conflicting duplicate upload intervals": {
    "en": "Conflicting duplicate upload intervals",
    "nl": "Er staan verschillende waarden voor hetzelfde meetinterval in de upload."
  },
  "upload period has too many measurements": {
    "en": "Upload period has too many measurements",
    "nl": "De uploadperiode bevat te veel meetpunten."
  },
  "upload measurement type does not match the connection": {
    "en": "Upload measurement type does not match the connection",
    "nl": "De meetreeks past niet bij het energietype van de aansluiting."
  },
  "upload interval has an invalid or ambiguous local time": {
    "en": "Upload interval has an invalid or ambiguous local time",
    "nl": "Het meetinterval bevat een ongeldige of dubbelzinnige lokale tijd."
  },
  "upload source file exceeds the 5 mb archive limit": {
    "en": "Upload source file exceeds the 5 MB archive limit",
    "nl": "Het bronbestand is groter dan de archieflimiet van 5 MB."
  },
  "upload source file not found": {
    "en": "Upload source file not found",
    "nl": "Het oorspronkelijke uploadbestand is niet gevonden."
  },
  "upload source connection not found": {
    "en": "Upload source connection not found",
    "nl": "Een aansluiting uit het oorspronkelijke bestand is niet gevonden."
  },
  "invalid upload history year": {
    "en": "Invalid upload history year",
    "nl": "Ongeldig jaar voor uploadhistorie."
  },
  "legacy measurements require migration before deletion": {
    "en": "Legacy measurements require migration before deletion",
    "nl": "Deze oudere meetdata moeten eerst worden gemigreerd voordat je de periode kunt verwijderen."
  },
  "invalid upload history offset": {
    "en": "Invalid upload history offset",
    "nl": "Ongeldige pagina voor uploadhistorie."
  },
  "only the original uploader or an administrator can download this file": {
    "en": "Only the original uploader or an administrator can download this file",
    "nl": "Alleen de oorspronkelijke uploader of een beheerder kan dit bestand downloaden."
  },
  "measurement data changed or is still updating; refresh and review before changing this period": {
    "en": "Measurement data changed or is still updating; refresh and review before changing this period",
    "nl": "De meetdata zijn gewijzigd of worden nog bijgewerkt. Vernieuw en controleer de periode voordat je deze wijzigt."
  },
  "refresh": {
    "en": "Refresh",
    "nl": "Vernieuwen"
  },
  "available": {
    "en": "Available",
    "nl": "Beschikbaar"
  },
  "upload details": {
    "en": "Upload details",
    "nl": "Uploaddetails"
  },
  "calendar period": {
    "en": "Calendar period",
    "nl": "Kalenderperiode"
  },
  "processing history": {
    "en": "Processing history",
    "nl": "Verwerkingshistorie"
  },
  "period actions": {
    "en": "Period actions",
    "nl": "Periodeacties"
  },
  "back to overview": {
    "en": "Back to overview",
    "nl": "Terug naar overzicht"
  },
  "volumes by period. open details for files and changes.": {
    "en": "Volumes by period. Open Details for files and changes.",
    "nl": "Volumes per periode. Open Details voor bestanden en wijzigingen."
  },
  "upload details could not be loaded": {
    "en": "Upload details could not be loaded",
    "nl": "De uploaddetails konden niet worden geladen"
  },
  "identical measurements received again. the volume was not changed.": {
    "en": "Identical measurements received again. The volume was not changed.",
    "nl": "Dezelfde meetgegevens zijn opnieuw ontvangen. Het volume is niet gewijzigd."
  },
  "the original file, uploader and upload time are unavailable for these measurements.": {
    "en": "The original file, uploader and upload time are unavailable for these measurements.",
    "nl": "Het oorspronkelijke bestand, de uploader en het uploadmoment zijn bij deze meetgegevens niet vastgelegd."
  },
  "loading": {
    "en": "Loading",
    "nl": "Laden"
  },
  "uploads": {
    "en": "Uploads",
    "nl": "Uploads"
  },
  "all uploads at this location": {
    "en": "All uploads at this location",
    "nl": "Alle uploads op deze locatie"
  },
  "download excel": {
    "en": "Download Excel",
    "nl": "Excel downloaden"
  },
  "upload template": {
    "en": "Upload template",
    "nl": "Invulsjabloon"
  },
  "period overview": {
    "en": "Period overview",
    "nl": "Periodeoverzicht"
  },
  "add upload": {
    "en": "Add upload",
    "nl": "Upload toevoegen"
  },
  "excel upload template": {
    "en": "Excel upload template",
    "nl": "Excel-invulsjabloon"
  },
  "choose a connection": {
    "en": "Choose a connection",
    "nl": "Kies een aansluiting"
  },
  "recognise connections from the file": {
    "en": "Recognise connections from the file",
    "nl": "Aansluitingen herkennen uit het bestand"
  },
  "from month": {
    "en": "From month",
    "nl": "Vanaf maand"
  },
  "through month": {
    "en": "Through month",
    "nl": "Tot en met maand"
  },
  "measurements per": {
    "en": "Measurements per",
    "nl": "Meetwaarden per"
  },
  "quarter-hour": {
    "en": "Quarter-hour",
    "nl": "Kwartier"
  },
  "excel file": {
    "en": "Excel file",
    "nl": "Excel-bestand"
  },
  "review upload": {
    "en": "Review upload",
    "nl": "Upload controleren"
  },
  "volume in file": {
    "en": "Volume in file",
    "nl": "Volume in bestand"
  },
  "import upload": {
    "en": "Import upload",
    "nl": "Upload importeren"
  },
  "upload processed": {
    "en": "Upload processed",
    "nl": "Upload verwerkt"
  },
  "the location, connection, units and periods are prefilled. only enter your measured values.": {
    "en": "The location, connection, units and periods are prefilled. Only enter your measured values.",
    "nl": "Locatie, aansluiting, eenheden en perioden worden ingevuld. Je hoeft alleen je meetwaarden toe te voegen."
  },
  "use the prefilled template or an existing flowmaps upload file. maximum 5 mb.": {
    "en": "Use the prefilled template or an existing Flowmaps upload file. Maximum 5 MB.",
    "nl": "Gebruik het invulsjabloon of een bestaand Flowmaps-uploadbestand. Maximaal 5 MB."
  },
  "i approve updating existing measurements in these periods.": {
    "en": "I approve updating existing measurements in these periods.",
    "nl": "Ik geef toestemming om bestaande meetwaarden in deze perioden bij te werken."
  },
  "this file includes a deleted period. restore it in details before uploading again.": {
    "en": "This file includes a deleted period. Restore it in Details before uploading again.",
    "nl": "Dit bestand bevat een verwijderde periode. Herstel deze eerst bij Details voordat je opnieuw uploadt."
  },
  "measurements have changed. review the upload again.": {
    "en": "Measurements have changed. Review the upload again.",
    "nl": "De meetgegevens zijn gewijzigd. Controleer de upload opnieuw."
  },
  "the source file must be smaller than 5 mb": {
    "en": "The source file must be smaller than 5 MB",
    "nl": "Het bronbestand mag maximaal 5 MB groot zijn"
  },
  "the file contains an unknown connection": {
    "en": "The file contains an unknown connection",
    "nl": "Het bestand bevat een onbekende aansluiting"
  },
  "the measurement does not match the connection": {
    "en": "The measurement does not match the connection",
    "nl": "De meetsoort past niet bij de aansluiting"
  },
  "the unit does not match the connection": {
    "en": "The unit does not match the connection",
    "nl": "De eenheid past niet bij de aansluiting"
  },
  "a measurement is not a valid number": {
    "en": "A measurement is not a valid number",
    "nl": "Een meetwaarde is geen geldig getal"
  },
  "invalid local time": {
    "en": "Invalid local time",
    "nl": "Een datum of tijd is ongeldig"
  },
  "invalid interval duration": {
    "en": "Invalid interval duration",
    "nl": "Een meetinterval heeft een ongeldige duur"
  },
  "invalid utc offset": {
    "en": "Invalid UTC offset",
    "nl": "Het tijdverschil met UTC is ongeldig"
  },
  "choose a valid period": {
    "en": "Choose a valid period",
    "nl": "Kies een geldige periode"
  },
  "choose a shorter period": {
    "en": "Choose a shorter period",
    "nl": "Kies een kortere periode"
  },
  "select at least one source": {
    "en": "Select at least one source",
    "nl": "Selecteer minimaal één bron"
  },
  "the file contains conflicting duplicate measurements": {
    "en": "The file contains conflicting duplicate measurements",
    "nl": "Het bestand bevat verschillende meetwaarden voor hetzelfde meetinterval"
  },
  "use a flowmaps upload template": {
    "en": "Use a Flowmaps upload template",
    "nl": "Gebruik een Flowmaps-invulsjabloon"
  },
  "the file contains no filled measurement values": {
    "en": "The file contains no filled measurement values",
    "nl": "Het bestand bevat geen ingevulde meetwaarden"
  },
  "narrow the connection selection before uploading": {
    "en": "Narrow the connection selection before uploading",
    "nl": "Beperk de aansluitingenselectie voordat je uploadt"
  },
  "you cannot upload to this connection": {
    "en": "You cannot upload to this connection",
    "nl": "Je hebt geen rechten om voor deze aansluiting te uploaden"
  },
  "upload could not be processed": {
    "en": "Upload could not be processed",
    "nl": "De upload kon niet worden verwerkt"
  },
  "no periods match the selected sources": {
    "en": "No periods match the selected sources",
    "nl": "Geen perioden voor de geselecteerde bronnen"
  },
  "fill only the value column. leave missing measurements empty; enter 0 only for measured zero consumption. keep the connection, unit and time columns unchanged.": {
    "en": "Fill only the Value column. Leave missing measurements empty; enter 0 only for measured zero consumption. Keep the connection, unit and time columns unchanged.",
    "nl": "Vul alleen de kolom Waarde in. Laat ontbrekende meetwaarden leeg; vul alleen 0 in voor gemeten nulverbruik. Laat de aansluiting, eenheid en tijdkolommen ongewijzigd."
  },
  "instructions": {
    "en": "Instructions",
    "nl": "Instructies"
  },
  "upload saved. measurements are being updated; refresh shortly.": {
    "en": "Upload saved. Measurements are being updated; refresh shortly.",
    "nl": "De upload is opgeslagen. Meetgegevens worden nog bijgewerkt; vernieuw het overzicht zo nodig."
  },
  "new": {
    "en": "New",
    "nl": "Nieuw"
  },
  "uploads at this location": {
    "en": "Uploads at this location",
    "nl": "Uploads op deze locatie"
  },
  "manage uploads": {
    "en": "Manage uploads",
    "nl": "Uploads beheren"
  },
  "save the connection first": {
    "en": "Save the connection first",
    "nl": "Sla de aansluiting eerst op"
  },
  "review and approve changed measurements before uploading": {
    "en": "Review and approve changed measurements before uploading",
    "nl": "Controleer de afwijkende meetwaarden en geef toestemming voordat je uploadt"
  },
  "assessed on": {
    "en": "Assessed on",
    "nl": "Opgenomen op"
  },
  "certificate holder": {
    "en": "Certificate holder",
    "nl": "Certificaathouder"
  },
  "close energy label details": {
    "en": "Close energy label details",
    "nl": "Energielabelinformatie sluiten"
  },
  "this energy label is linked to ep-online through the bag addressable object id. flowmaps periodically checks for a new registration and updates automatically linked labels. manual selections are preserved.": {
    "en": "This energy label is linked to EP-Online through the BAG addressable object ID. Flowmaps periodically checks for a new registration and updates automatically linked labels. Manual selections are preserved.",
    "nl": "Dit energielabel is via het verblijfsobject gekoppeld aan EP-Online. Flowmaps controleert periodiek op een nieuwe registratie en werkt automatisch gekoppelde labels bij. Handmatige keuzes blijven behouden."
  },
  "ep-online energy label details": {
    "en": "EP-Online energy label details",
    "nl": "EP-Online-gegevens van het energielabel"
  },
  "registered on": {
    "en": "Registered on",
    "nl": "Geregistreerd op"
  },
  "last successful check": {
    "en": "Last successful check",
    "nl": "Laatst succesvol gecontroleerd"
  },
  "ennatuurlijk requests are waiting. try saving again later.": {
    "en": "Ennatuurlijk requests are waiting. Try saving again later.",
    "nl": "De aanvraag kan nu nog niet worden verstuurd. Probeer later opnieuw op te slaan."
  },
  "review the manual cooling or submeter assignment before changing the heat source": {
    "en": "Review the manual cooling or submeter assignment before changing the heat source",
    "nl": "Controleer eerst de gekoppelde handmatige koude- of tussenmeters voordat je de warmtebron wijzigt."
  },
  "review manual history that ends within a day or after today before changing the source": {
    "en": "Review manual history that ends within a day or after today before changing the source",
    "nl": "Controleer eerst de handmatige historie: de laatste meetperiode moet op een daggrens eindigen en mag niet na vandaag liggen."
  },
  "review overlapping manual and automatic history before changing the source": {
    "en": "Review overlapping manual and automatic history before changing the source",
    "nl": "Controleer eerst de overlap tussen handmatige en automatische meetgegevens voordat je de bron wijzigt."
  },
  "the manual heat source has been replaced by ennatuurlijk and cannot be reactivated": {
    "en": "The manual heat source has been replaced by Ennatuurlijk and cannot be reactivated",
    "nl": "De handmatige warmtebron is opgevolgd door Ennatuurlijk en kan niet opnieuw worden geactiveerd."
  },
  "manual measurements cannot extend beyond the ennatuurlijk source change": {
    "en": "Manual measurements cannot extend beyond the Ennatuurlijk source change",
    "nl": "Handmatige meetgegevens mogen niet overlappen met de periode van de Ennatuurlijk-koppeling."
  }
}
